import { enLegalContent } from '../legalContent'

export default {
  brand: {
    logoAlt: 'LPT logo'
  },
  legal: enLegalContent,
  language: {
    en: 'English',
    fr: 'French',
    es: 'Spanish',
    zh: 'Chinese',
    de: 'German'
  },
  navbar: {
    Index: 'Home',
    Products: 'Products',
    Audit: 'Audit',
    solution: 'Solutions',
    about: 'About Us',
    News: 'News',
    Customer_Service: 'Features & Solution',
    controlCenter: 'Control Center',
    login: 'Login',
    Language: 'Language',
    logout: 'Logout',
    logoutSuccess: 'Logout successfully',
    FAQ: 'FAQ',
    AboutLPT: 'About LPT',
    LPTIntro: 'LPT Intro',
    ContactLPT: 'Contact LPT',
    Company: 'Company',
    IndustryBrain: 'Industry Brain',
    CloudRecruitment: 'Cloud Recruitment',
    InnovationServices: 'Enterprise Innovation Services',
    Consulting: 'Industrial Consulting',
    ContentCenter: 'Content Center',
    IndustryReports: 'Industry Reports',
    SelectedArticles: 'Selected Articles',
    MediaReports: 'Media Reports',
    LPTResearch: 'LPT Research Institute',
    LPTIntroduction: 'About LPT',
    BuyNow: 'Buy now'
  },
  serverConfig: {
    computeInstance: {
      title: 'Compute Instances',
      recommend: 'Recommended',
      types: {
        g7: { name: 'General-purpose G7', type: 'General purpose' },
        c7: { name: 'Compute-optimized C7', type: 'Compute optimized' },
        r7: { name: 'Memory-optimized R7', type: 'Memory optimized' }
      },
      specs: { cpu: ' vCPU', memory: ' GB' },
      price: { currency: '€', period: ' / month' }
    },
    storageConfig: {
      title: 'Storage Configuration',
      types: {
        essd: 'Enhanced SSD',
        essdDesc: 'Million-level IOPS',
        ssd: 'Standard SSD',
        ssdDesc: 'Enterprise-grade performance',
        hdd: 'High-efficiency HDD',
        hddDesc: 'High-capacity storage',
        performance: { iops: 'IOPS: ', latency: 'Latency: ' }
      },
      capacity: { label: 'Storage Capacity', unitGB: ' GB' }
    }
  },
  registration: {
    organization: 'Organization',
    legalRepresentative: 'Legal representative',
    businessRegistrationNumber: 'Business registration number',
    taxIdNumber: 'Tax ID number',
    businessAddress: 'Business address',
    phoneNumber: 'Phone number',
    wechatId: 'WeChat ID',
    email: 'Email',
    createPassword: 'Create password',
    repeatPassword: 'Repeat password',
    accept: 'I accept the',
    termsConditions: 'Terms and Conditions'
  },
  dialog: {
    termsTitle: 'Terms and Conditions'
  },
  common: {
    close: 'Close',
    loading: 'Loading...'
  },
  validation: {
    required: 'This field is required.',
    lengthRange: 'Please enter between {min} and {max} characters.',
    regNumberFormat: 'Enter a valid 15-character registration number.',
    passwordComplexity: 'Use at least 8 characters with uppercase, lowercase and a number.',
    passwordMismatch: 'The passwords do not match.',
    agreementRequired: 'Please accept the terms and conditions.'
  },
  message: {
    validationFailed: 'Please correct the highlighted fields.'
  },
  payment: {
    steps: {
      methodSelection: 'Payment method',
      paymentProcess: 'Payment',
      paymentResult: 'Result'
    },
    methods: {
      wechat: { name: 'WeChat Pay', tip: 'Recommended for WeChat users' },
      alipay: { name: 'Alipay', tip: 'Supports Huabei and Yu’e Bao' },
      mastercard: { name: 'Mastercard', tip: 'Supports international credit cards' }
    },
    qrCode: {
      scanPrompt: 'Scan the {method} QR code to pay',
      countdown: 'QR code expires in {seconds}s'
    },
    form: {
      cardNumber: 'Card number',
      expiryDate: 'Expiry date',
      cvv: 'CVV',
      placeholders: {
        cardNumber: 'Enter card number',
        expiry: 'Select expiry date',
        cvv: 'Enter CVV'
      }
    },
    buttons: { previous: 'Previous', payNow: 'Pay now' },
    errors: { bankBusy: 'The banking system is busy. Please try again later.' },
    result: {
      success: { title: 'Payment successful', subTitle: 'Your order has been paid. We are preparing your products.' },
      failed: { title: 'Payment failed', subTitle: 'We could not complete your payment. Please try again.' },
      returnHome: 'Return home'
    }
  },
  periodSelect: {
    Monthlypurchase: 'Monthly purchase',
    Annual: 'Annual'
  },
  datePicker: {
    rangeSeparator: 'to',
    startMonth: 'Start month',
    endMonth: 'End month'
  },
  networkConfig: {
    title: 'Network Configuration'
  },
  priceSummary: {
    title: 'Price Summary',
    serviceDuration: 'Service duration: {months} months',
    unitPrice: 'Unit price: {price}',
    totalPrice: 'Total price: {total}'
  },
  orderDetails: {
    title: 'Order Details',
    companyName: 'Company',
    template: 'Template',
    storage: 'Storage',
    storageUnitGB: 'GB',
    computeLevel: 'Compute level',
    servicePeriod: 'Service period',
    totalAmount: 'Total amount',
    defaultPeriod: 'July 2023 to June 2024'
  },
  agreement: {
    readAndAgree: 'I have read and agree to',
    serviceAgreement: 'Service Agreement',
    and: 'and',
    privacyPolicy: 'Privacy Policy'
  },
  template: {
    header: { title: 'Select Audit Templates', selectedCount: '{count} selected' },
    tags: { pro: 'PRO', basic: 'BASIC' },
    names: {
      iso9001: 'ISO 9001', iatf16949: 'IATF 16949', vda63: 'VDA 6.3', vda65: 'VDA 6.5',
      individualPro: 'Individual Template Creator (Pro)', individualBasic: 'Individual Template Creator'
    },
    description: 'Intelligent production management system for the manufacturing industry.',
    alerts: {
      incompatible: 'This template is incompatible with the templates already selected.',
      conflict: 'Template {template} conflicts with the selected templates: {selected}'
    }
  },
  demo: {
    title: 'Book a Product Demo',
    subtitle: 'Tell us about your needs and our team will get in touch.',
    form: {
      serviceLabel: 'Product or service of interest',
      servicePlaceholder: 'Select a product or service',
      services: {
        auditPlatform: 'Audit platform',
        complianceManagement: 'Compliance management',
        riskAssessment: 'Risk assessment',
        auditConsulting: 'Audit consulting'
      },
      nameLabel: 'Name', namePlaceholder: 'Enter your name',
      phoneLabel: 'Phone number', phonePlaceholder: 'Enter your phone number',
      codeLabel: 'Verification code', codePlaceholder: 'Enter verification code', getCodeButton: 'Get code',
      emailLabel: 'Email', emailPlaceholder: 'Enter your email',
      companyLabel: 'Government / park / organization / company', companyPlaceholder: 'Enter your company name',
      positionLabel: 'Job title', positionPlaceholder: 'Enter your job title',
      remarksLabel: 'Remarks', remarksPlaceholder: 'Describe your questions or needs (max. 200 characters)',
      privacyAgreement: 'By submitting, you agree to LPT Creation\'s Privacy Policy',
      submitButton: 'Book now'
    }
  },
  back: 'Back',
  controlCenter: {
    sidebar: {
      title: 'Control Center',
      subtitle: 'Audit and payment administration',
      dashboard: 'Audit Overview',
      paymentDashboard: 'Payment Dashboard',
      companyEntitlements: 'Company Purchases',
      myProducts: 'My Products',
      catalog: 'Catalog Management',
      orders: 'Order Management',
      invoices: 'Invoice Management',
      tickets: 'Ticket Management',
      addOnManagement: 'Add-on Management',
      userManagement: 'User Management',
      permissionManagement: 'Permission Management',
      systemSettings: 'System Settings',
      appManagement: 'Application Management',
      accountInfo: 'Account'
    },
    invoices: {
      title: 'Invoice Management',
      subtitle: 'Upload and view invoices for purchase orders.',
      notUploaded: 'Not uploaded',
      deleteFile: 'Delete file',
      deleting: 'Deleting...',
      deleteConfirm: 'Delete this invoice file? You can upload a replacement afterward.',
      deleteSuccess: 'Invoice file deleted.',
      deleteError: 'Failed to delete the invoice file.',
      snapshot: 'Captured snapshot',
      overview: {
        total: 'Total orders',
        uploaded: 'Uploaded on this page',
        pending: 'Awaiting upload',
        coverage: 'Page coverage'
      },
      columns: {
        invoice: 'Invoice'
      }
    },
    accessDenied: {
      title: 'Administrator access required',
      description: 'This area is only available to administrator accounts.'
    },
    common: {
      loading: 'Loading...',
      shop: 'SHOP',
      refresh: 'Refresh',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      enable: 'Enable',
      disable: 'Disable',
      actions: 'Actions',
      all: 'All',
      search: 'Search',
      reset: 'Reset',
      viewDetails: 'View details',
      close: 'Close',
      confirm: 'Confirm',
      exitToHome: 'Back to home',
      unknown: 'Unknown',
      status: 'Status'
    },
    statusLabels: {
      PENDING: 'Pending',
      SUCCESS: 'Success',
      ACTIVE: 'Active',
      FAILED: 'Failed',
      CANCELED: 'Canceled',
      PAST_DUE: 'Past due',
      UNKNOWN: 'Unknown'
    },
    billingCycleLabels: {
      one_year: '1 Year',
      two_year: '2 Years'
    },
    ticketStatusLabels: {
      OPEN: 'Open',
      CLOSED: 'Closed',
      UNKNOWN: 'Unknown'
    },
    ticketCategories: {
      REFUND: 'Refund',
      LICENSE: 'License',
      LOGIN: 'Login',
      AUDIT: 'Audit',
      OTHER: 'Other'
    },
    ticketAuthorTypes: {
      EMPLOYEE: 'LPT Employee',
      CUSTOMER: 'Customer',
      UNKNOWN: 'Unknown'
    },
    dashboard: {
      title: 'Payment Dashboard',
      subtitle: 'Track orders, revenue and popular products in one place.',
      totalOrders: 'Total Orders',
      successfulOrders: 'Successful Orders',
      pendingOrders: 'Pending Orders',
      failedOrders: 'Failed Orders',
      totalRevenue: 'Total Revenue',
      trendTitle: 'Last 7 Days',
      trendDate: 'Date',
      trendOrders: 'Orders',
      trendRevenue: 'Revenue',
      recentOrders: 'Recent Orders',
      popularItems: 'Popular Items',
      orderNo: 'Order No.',
      company: 'Company',
      amount: 'Amount',
      createdAt: 'Created At',
      noPopularItems: 'No popular items yet.',
      loadError: 'Failed to load dashboard data.'
    },
    companyEntitlements: {
      title: 'Company Purchases',
      subtitle: 'View all companies, purchased capabilities and license validity dates.',
      keywordPlaceholder: 'Search by company, order, user or package',
      empty: 'No company purchases found.',
      loadError: 'Failed to load company purchases.',
      seatSummary: '{auditors} auditors / {admins} admins',
      stats: {
        companies: 'Companies',
        activeCompanies: 'Active Companies',
        entitlements: 'Entitlements',
        seats: 'Total Seats'
      },
      columns: {
        company: 'Company',
        activeEntitlements: 'Active / Total',
        purchasedItems: 'Purchased Items',
        seats: 'Seats',
        startsAt: 'Start Date',
        expiresAt: 'Expiry Date'
      },
      fields: {
        billingCycle: 'Billing Cycle',
        validity: 'Validity',
        seats: 'Seats',
        updatedAt: 'Updated At',
        languages: 'Languages',
        standards: 'Audit Templates'
      }
    },
    myProducts: {
      title: 'My Products',
      subtitle: 'Review the products and add-ons owned by the current account.',
      activeKicker: 'In Use',
      activeTitle: 'Currently active',
      expiredKicker: 'Archive',
      expiredTitle: 'Expired products',
      expiresAt: 'Expires at',
      expiredAt: 'Expired at',
      startsAt: 'Starts at',
      sourceOrder: 'Order',
      quantity: '{count} pcs',
      loadError: 'Failed to load your products.',
      emptyActiveTitle: 'No active products',
      emptyActiveText: 'Purchased products will appear here after payment succeeds.',
      emptyExpiredTitle: 'No expired products',
      emptyExpiredText: 'Expired products will be archived here.',
      stats: {
        active: 'Products in use',
        expired: 'Expired products',
        total: '{count} total products',
        nextExpiry: '{product} expires on {date}',
        noExpiry: 'No expiry date available'
      },
      groups: {
        package: {
          kicker: 'Package',
          title: 'Packages',
          emptyActiveTitle: 'No active packages',
          emptyActiveText: 'Purchased packages will appear here.',
          emptyExpiredTitle: 'No expired packages',
          emptyExpiredText: 'Expired packages will be listed here.'
        },
        language: {
          kicker: 'Language',
          title: 'Languages',
          emptyActiveTitle: 'No active languages',
          emptyActiveText: 'Purchased languages will appear here.',
          emptyExpiredTitle: 'No expired languages',
          emptyExpiredText: 'Expired languages will be listed here.'
        },
        standard: {
          kicker: 'Standards',
          title: 'Standards',
          emptyActiveTitle: 'No active Standards',
          emptyActiveText: 'Purchased Standards will appear here.',
          emptyExpiredTitle: 'No expired Standards',
          emptyExpiredText: 'Expired Standards will be listed here.'
        },
        licence: {
          kicker: 'Licences',
          title: 'Licences',
          emptyActiveTitle: 'No active licences',
          emptyActiveText: 'Purchased licences will appear here.',
          emptyExpiredTitle: 'No expired licences',
          emptyExpiredText: 'Expired licences will be listed here.'
        }
      },
      status: {
        active: 'Active'
      },
      types: {
        licence: 'Licences',
        auditorSeat: 'Auditor Licences',
        adminSeat: 'Admin Seats'
      },
      descriptions: {
        plan: 'Main subscription package · {cycle}',
        language: 'Additional language capability',
        standard: 'Additional audit template',
        seat: 'Additional licence quantity: {count}',
        addOn: 'Purchased add-on capability'
      },
      actions: {
        createAuditor: 'Create User'
      }
    },
    catalog: {
      title: 'Catalog Management',
      subtitle: 'Maintain product names, prices, seat tiers and availability.',
      create: 'New Item',
      createTitle: 'Create Catalog Item',
      editTitle: 'Edit Catalog Item',
      enabled: 'Enabled',
      disabled: 'Disabled',
      unlimited: 'Unlimited',
      loadError: 'Failed to load catalog items.',
      createSuccess: 'Catalog item created successfully.',
      updateSuccess: 'Catalog item updated successfully.',
      saveError: 'Failed to save catalog item.',
      enableSuccess: 'Catalog item enabled successfully.',
      disableSuccess: 'Catalog item disabled successfully.',
      columns: {
        type: 'Type',
        code: 'Code',
        name: 'Name',
        currency: 'Currency',
        oneYear: '1 Year Price',
        twoYears: '2 Year Price',
        seatCount: 'licences',
        languageLimit: 'Language Limit',
        sortOrder: 'Sort Order',
        enabled: 'Status'
      },
      types: {
        plan: 'Plan',
        language: 'Language',
        standard: 'Audit Template',
        auditorSeat: 'Auditor Seat',
        adminSeat: 'Admin Seat'
      }
    },
    orders: {
      title: 'Order Management',
      subtitle: 'Search and inspect all purchase orders.',
      keywordPlaceholder: 'Search by order number or company',
      syncStatus: 'Sync Status',
      uploadInvoice: 'Upload Invoice',
      invoiceUploading: 'Uploading...',
      viewInvoice: 'View Invoice',
      storageTag: 'Storage · Attached',
      invoiceUploadSuccess: 'Invoice uploaded successfully.',
      invoiceUploadError: 'Failed to upload invoice.',
      invoiceTypeError: 'Please upload a PDF, PNG or JPG invoice.',
      invoiceSizeError: 'Invoice file must be 10 MB or smaller.',
      detailTitle: 'Order Detail',
      invoiceItems: 'Invoice Items',
      companyInfo: 'Company Information',
      defaultInvoiceInfo: 'Default Invoice Information',
      noDefaultInvoiceInfo: 'No default invoice information has been set.',
      contactName: 'Contact Name',
      email: 'Email',
      phone: 'Phone',
      registrationNumber: 'Registration Number',
      address: 'Address',
      loadError: 'Failed to load orders.',
      detailError: 'Failed to load order detail.',
      syncSuccess: 'Order status synced successfully.',
      syncError: 'Failed to sync order status.',
      columns: {
        orderNo: 'Order No.',
        company: 'Company',
        plan: 'Plan',
        billingCycle: 'Billing Cycle',
        amount: 'Amount',
        paymentMethod: 'Payment Method',
        createdAt: 'Created At'
      }
    },
    tickets: {
      title: 'Ticket Management',
      subtitle: 'Search, review and respond to customer support tickets.',
      create: 'New Ticket',
      createTitle: 'Create Ticket',
      detailTitle: 'Ticket Detail',
      searchPlaceholder: 'Search tickets',
      titlePlaceholder: 'Enter ticket title',
      categoryPlaceholder: 'Select ticket category',
      titleRequired: 'Please enter a ticket title.',
      categoryRequired: 'Please select a ticket category.',
      empty: 'No tickets found.',
      messages: 'Messages',
      noMessages: 'No messages yet.',
      replyPlaceholder: 'Write a message',
      sendMessage: 'Send Message',
      closeTicket: 'Close Ticket',
      closeConfirmTitle: 'Close Ticket',
      closeConfirmMessage: 'Are you sure you want to close this ticket?',
      loadError: 'Failed to load tickets.',
      detailError: 'Failed to load ticket detail.',
      createSuccess: 'Ticket created successfully.',
      createError: 'Failed to create ticket.',
      replyRequired: 'Please enter a message.',
      replySuccess: 'Message sent successfully.',
      replyError: 'Failed to send message.',
      closeSuccess: 'Ticket closed successfully.',
      closeError: 'Failed to close ticket.',
      missingId: 'Ticket ID is missing.',
      columns: {
        id: 'Ticket ID',
        title: 'Title',
        category: 'Category',
        createdBy: 'Created By',
        createdAt: 'Created At'
      }
    },
    auditDashboard: {
      title: 'Audit Overview',
      eyebrow: 'Executive command dashboard',
      subtitle: 'Track audit purchases, entitlements, seats, standards and operational health.',
      startNewAudit: 'Start New Audit',
      activeAuditors: 'Active Auditors',
      auditorsAvailable: '{count} auditors available',
      purchasedModules: 'Purchased Modules',
      newThisMonth: '{count} new this month',
      auditsInProgress: 'Audits In Progress',
      ongoing: '{count} ongoing',
      reportsToReview: 'Reports To Review',
      viewReports: 'View Reports',
      activityOverview: 'Audit Activity',
      timePeriods: {
        month: 'Month',
        week: 'Week',
        day: 'Day'
      },
      inProgressAudits: 'Audits In Progress',
      projectName: 'Project Name',
      leadAuditor: 'Lead Auditor',
      progress: 'Progress',
      dueDate: 'Due Date',
      recentReports: 'Recent Reports',
      completedBy: 'Completed by {auditor} on {date}',
      loadError: 'Failed to load audit overview.',
      cards: {
        totalOrders: 'Total Orders',
        orderMix: '{success} successful / {pending} pending',
        totalRevenue: 'Total Revenue',
        failedOrders: '{count} failed or canceled orders',
        activeEntitlements: 'Active Entitlements',
        expiring: '{count} expiring soon',
        auditorSeats: 'Auditor Seats',
        adminSeats: '{count} admin seats',
        catalogItems: 'Enabled Catalog',
        catalogTotal: '{count} total catalog items',
        invoiceCoverage: 'Invoice Coverage',
        invoiceUploaded: '{count} orders invoiced'
      },
      sections: {
        orderMovement: 'Order Movement',
        orderMovementSub: 'Daily order volume for the last 14 days',
        auditHealth: 'Audit Business Health',
        auditHealthSub: 'Success, invoice and entitlement activation mix',
        revenueMix: 'Revenue by Plan',
        capabilityComposition: 'Capability Composition',
        capabilityCompositionSub: 'Orders, seats, catalog and invoice readiness',
        entitlementHealth: 'Entitlement Health',
        entitlementHealthSub: 'Current license lifecycle status',
        methodMix: 'Payment Method Mix',
        methodMixSub: 'Order count by selected payment method',
        standardDemand: 'Standard Demand',
        standardDemandSub: 'Most purchased audit templates',
        recentOrders: 'Recent Orders',
        recentOrdersSub: 'Latest customer purchase activity',
        expiringEntitlements: 'Expiring Entitlements',
        expiringEntitlementsSub: 'Licenses due within 30 days'
      },
      labels: {
        healthScore: 'Health score',
        orders: 'Orders',
        successOrders: 'Success orders',
        auditorSeats: 'Auditor seats',
        adminSeats: 'Admin seats',
        enabledCatalog: 'Enabled catalog',
        invoices: 'Invoices',
        days: 'days'
      },
      empty: {
        noData: 'No data available.',
        noOrders: 'No recent orders.',
        noExpiring: 'No entitlements expiring soon.'
      },
      paymentMethods: {
        card: 'Card',
        alipay: 'Alipay',
        wechat: 'WeChat Pay',
        visa: 'Visa',
        mastercard: 'Mastercard',
        unknown: 'Unknown'
      },
      plans: {
        starter: 'Starter',
        professional: 'Professional',
        enterprise: 'Enterprise'
      }
    },
    userManagement: {
      subtitle: 'Manage auditors, profiles and account permissions.',
      createAuditor: 'Create User',
      allUserTypes: 'All User Types',
      typeAdministrator: 'Administrator',
      typeAuditor: 'User',
      searchPlaceholder: 'Search users by name or email',
      myProfile: 'My Profile',
      noAuditorsFound: 'No auditors found.',
      userName: 'User Name',
      email: 'Email',
      userType: 'User Type',
      createdDate: 'Created Date',
      lastUsed: 'Last used',
      showUnassignableUsers: 'Show unassignable users',
      assignSeat: 'Assign Seat',
      selectSeat: 'Select a seat',
      noAvailableSeats: 'No available seats. Please purchase more seats.',
      assignSeatDeniedTitle: 'Cannot Assign Seat',
      assignSeatDeniedMessage: 'Only users of type AUDITOR can be assigned a seat. The current user type is not Auditor.',
      noAvailableLicence: 'No available licence. Please purchase more Licences first.',
      neverLogged: 'Never logged in',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      actions: 'Actions',
      editAuditor: 'Edit Auditor',
      permissionSetting: 'Permission Settings',
      changePassword: 'Change password',
      changePasswordTitle: 'Change Password',
      delete: 'Delete',
      addAuditorModalTitle: 'Add Auditor',
      firstName: 'First Name',
      lastName: 'Last Name',
      cancel: 'Cancel',
      saving: 'Saving...',
      saveChanges: 'Save Changes',
      personalInfo: 'Personal Information',
      phoneNumber: 'Phone Number',
      nationality: 'Nationality',
      sex: 'Gender',
      organizationInfo: 'Organization Information',
      organizationName: 'Organization Name',
      legalName: 'Legal Name',
      contactEmail: 'Contact Email',
      address: 'Address',
      quotaInfo: 'Quota Information',
      maxAuditorCount: 'Maximum Auditors',
      accountCreatedDate: 'Account Created Date',
      close: 'Close',
      updateSuccess: 'User updated successfully.',
      addSuccess: 'User added successfully.',
      updateErrorOnceAYear: 'This information can only be changed once per year.',
      saveError: 'Failed to save user.',
      loadError: 'Failed to load auditors.',
      confirmDeleteMsg: 'Are you sure you want to delete {userName}?',
      confirmDeleteTitle: 'Delete Auditor',
      deleteSuccess: 'Auditor deleted successfully.',
      deleteError: 'Failed to delete user.',
      createAuditorTitle: 'Create User',
      basicInfo: 'Basic Information',
      firstNamePlaceholder: 'Enter first name',
      lastNamePlaceholder: 'Enter last name',
      emailPlaceholder: 'Enter email address',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      passwordHint: 'Use at least 8 characters with letters and numbers.',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      passwordRequired: 'Please enter the current password and new password.',
      passwordMismatch: 'Passwords do not match.',
      changePasswordSuccess: 'Password changed successfully.',
      changePasswordError: 'Failed to change password.',
      sexUnknown: 'Prefer not to say',
      sexMale: 'Male',
      sexFemale: 'Female',
      birthday: 'Birthday',
      phoneNumberPlaceholder: 'Enter phone number',
      selectNationality: 'Select nationality',
      addressInfo: 'Address Information',
      country: 'Country',
      selectCountry: 'Select country',
      stateOrProvince: 'State or Province',
      statePlaceholder: 'Enter state or province',
      city: 'City',
      cityPlaceholder: 'Enter city',
      postalCode: 'Postal Code',
      postalCodePlaceholder: 'Enter postal code',
      addressLine1: 'Address Line 1',
      addressLine1Placeholder: 'Enter street address',
      addressLine2: 'Address Line 2',
      addressLine2Placeholder: 'Enter apartment, suite or unit',
      enableUser: 'Enable user',
      creating: 'Creating...',
      createSuccess: 'User created successfully.',
      createError: 'Failed to create user.',
      permissionDialogTitle: 'Permissions for {userName}',
      permissions: 'Permissions',
      assignSuccess: 'Permissions updated successfully.',
      permissionLoadError: 'Failed to load permission data.',
      permissionGroups: {
        user: 'User Management',
        permission: 'Permission Management',
        group: 'Group Management',
        account: 'Account Management',
        audit: 'Audit Management',
        report: 'Report Management'
      }
    },
    permissionManagement: {
      subtitle: 'Configure permission policies and access control.',
      comingSoon: 'Permission management is coming soon.'
    },
    addOnManagement: {
      subtitle: 'Purchase additional languages, audit standards and licences for the current account.',
      currentPackage: 'Current Package',
      noPackage: 'No active Package',
      addOnAvailable: 'Add-ons available',
      addOnLocked: 'Add-ons locked',
      packageAvailable: 'The current Package supports add-on languages, Standards and licences.',
      starterRestriction: 'Starter package does not support add-ons. Please purchase a higher package.',
      purchaseDuration: 'Duration',
      chooseDuration: 'Choose add-on validity',
      forOneYear: 'for 1 year',
      forTwoYears: 'for 2 years',
      itemCount: '{count} items',
      standardTemplate: 'Audit standard template',
      licenceCapacity: 'Additional licence capacity',
      currentExpiry: 'Current expiry: {date}',
      notActive: 'Not active',
      expiryChange: 'Current {current} -> after add-on {projected}',
      emptyCategory: 'No add-ons available in this category.',
      emptySelection: 'Select one or more add-ons to create an order.',
      orderSummary: 'Order',
      selectedAddOns: 'Selected add-ons',
      total: 'Total',
      confirmAndPay: 'Confirm and pay',
      summaryNote: 'Prices exclude VAT. The final charge is confirmed by the payment order.',
      selectRequired: 'Please select at least one add-on.',
      createOrderError: 'Failed to create add-on order.',
      loadErrorTitle: 'Add-ons unavailable',
      loadError: 'Failed to load add-on options. Please refresh and try again.',
      checkout: 'Checkout',
      completePayment: 'Complete add-on payment',
      paymentIntro: 'Use the same secure payment methods as the purchase flow.',
      backToSelection: 'Back to selection',
      auditorSeatsName: '{count} auditor licences',
      auditorSeatsDesc: 'Additional auditor seats for audit execution and reports.',
      adminSeatsName: '{count} admin licences',
      adminSeatsDesc: 'Additional administrator seats for user and permission management.',
      licencesName: '{count} licences',
      licencesDesc: 'Add ordinary audit licences one by one for team members who perform audits and generate reports.',
      licenceSelectedCount: '{count} selected',
      licenceUnitPrice: '{price} / licence / month',
      licenceCountLabel: 'licences',
      decreaseLicence: 'Decrease licences',
      increaseLicence: 'Increase licences',
      singleCapability: 'Single capability',
      seatQuantity: '{count} seats',
      categories: {
        languages: {
          title: 'Languages',
          desc: 'Add audit system languages without changing the base package.'
        },
        standards: {
          title: 'Standards',
          desc: 'Purchase additional audit templates and extend existing ones.'
        },
        licences: {
          title: 'Licences',
          desc: 'Add ordinary licences one by one; supplier and client portals remain unlimited.'
        }
      },
      types: {
        language: 'Language',
        standard: 'Standard',
        licence: 'Licence',
        auditorSeat: 'Auditor seat',
        adminSeat: 'Admin seat',
        addOn: 'Add-on'
      }
    },
    systemSettings: {
      subtitle: 'Manage organization profile, address and contact details.',
      loading: 'Loading settings...',
      orgInfo: 'Organization Information',
      orgName: 'Organization Name',
      legalName: 'Legal Name',
      industry: 'Industry',
      selectIndustry: 'Please select one',
      regNum: 'Registration Number',
      taxId: 'Tax ID',
      addressContact: 'Address and Contact',
      address: 'Address',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal Code',
      contactEmail: 'Contact Email',
      phone: 'Phone',
      loadError: 'Failed to load organization settings.',
      updateSuccess: 'Organization settings updated successfully.',
      saveError: 'Failed to save organization settings.',
      industries: {
        healthCare: 'Health Care',
        dataAndAnalytics: 'Data & Analytics',
        finance: 'Financial Services',
        technology: 'Technology',
        education: 'Education',
        manufacturing: 'Manufacturing',
        retail: 'Retail',
        transportation: 'Transportation'
      }
    },
    appManagement: {
      title: 'Application Management',
      subtitle: 'Manage company applications - Provision, Suspend, Resume or Deprovision apps.',
      keywordPlaceholder: 'Search by app name, code or company',
      empty: 'No app data available.',
      loadError: 'Failed to load app list.',
      section: {
        active: 'Active Apps',
        suspend: 'Suspended Apps',
        notProvisioned: 'Not Provisioned Apps'
      },
      stats: {
        totalApps: 'Total Apps',
        activeApps: 'Active',
        suspendedApps: 'Suspended',
        notProvisionedApps: 'Not Provisioned'
      },
      columns: {
        appName: 'App Name',
        company: 'Company',
        status: 'Status',
        createdAt: 'Activated At',
        expiredAt: 'Expires At'
      },
      statusLabels: {
        ACTIVE: 'Active',
        SUSPENDED: 'Suspended',
        NOT_PROVISIONED: 'Not Provisioned',
        DEPROVISIONED: 'Deprovisioned'
      },
      actions: {
        provision: 'Provision',
        suspend: 'Suspend',
        resume: 'Resume',
        deprovision: 'Deprovision'
      },
      messages: {
        provisionSuccess: 'App provisioned successfully.',
        provisionError: 'Failed to provision app.',
        suspendSuccess: 'App suspended successfully.',
        suspendError: 'Failed to suspend app.',
        resumeSuccess: 'App resumed successfully.',
        resumeError: 'Failed to resume app.',
        deprovisionSuccess: 'App deprovisioned successfully.',
        deprovisionError: 'Failed to deprovision app.'
      },
      dialogs: {
        deprovision: {
          title: 'Deprovision App',
          message: 'Are you sure you want to deprovision app "{appName}"? This action cannot be undone.',
          confirm: 'Confirm Deprovision'
        }
      }
    },
    auditorSeatManagement: {
      title: 'Seat Status',
      empty: 'No seat data available.',
      loadError: 'Failed to load seat data.',
      forcedLogout: 'You do not have permission to access this page. You have been signed out automatically.',
      goToActivate: 'Go to Activate',
      buyNow: 'Buy now',
      unassigned: 'Unassigned',
      actions: {
        rename: 'Rename',
        assign: 'Assign',
        unassign: 'Unassign'
      },
      messages: {
        renameSuccess: 'Seat renamed successfully.',
        renameError: 'Failed to rename seat.',
        assignSuccess: 'Auditor assigned successfully.',
        assignError: 'Please contact Customer Service to unassign the seat.',
        unassignSuccess: 'Auditor unassigned successfully.',
        unassignError: 'Please contact Customer Service to unassign the seat.',
        copied: 'Copied'
      },
      fields: {
        name: 'Name',
        isAuditUser: 'Audit User',
        auditUserNumeral: 'Audit User No.',
        auditUserType: 'Audit User Type',
        notAuditUserPlaceholder: 'Not an audit user yet',
        hasSeat: 'Seat Status',
        hasSeatTooltipTrue: 'Already assigned to a seat',
        hasSeatTooltipFalse: 'No seat assigned',
        email: 'Email',
        lastLoginTime: 'Last Used',
        yes: 'Yes',
        no: 'No'
      },
      auditUserTypes: {
        AUDITOR: 'Auditor',
        AUDITOR_INTERNAL_USER: 'Auditor Internal User',
        SUPPLIER_REPRESENTATIVE: 'Supplier Representative',
        SUPPLIER_INTERNAL_USER: 'Supplier Internal User',
        CLIENT: 'Client Representative',
        GUEST: 'Guest',
        placeholder: '-'
      },
      dialogs: {
        rename: {
          title: 'Rename Seat',
          nameLabel: 'Seat Name'
        },
        assign: {
          title: 'Assign Auditor',
          auditorLabel: 'Select Auditor',
          auditorPlaceholder: 'Please select an auditor',
          searchPlaceholder: 'Search by name / email / audit user no.',
          countSuffix: 'items',
          empty: 'No matching users',
          assignableTag: 'Assignable',
          unassignableTag: 'Unassignable',
          warningTitle: 'Important Notice',
          warningMessage: 'Please carefully select the assigned auditor. Make sure the selected auditor is correct before proceeding. Once a seat has been assigned, it cannot be unassigned by yourself. Please contact customer support if you need to cancel the assignment.',
          acknowledgeLabel: 'I understand',
          showUnassignableLabel: 'Show unassignable users',
          nonAuditorBlockTip: 'Only "Auditor" users can be assigned a seat. The selected user is not an auditor.',
          seatReplaceWarning: 'The seat currently assigned to this user will be replaced.',
          notAuditUserInfo: 'Seats can only be assigned to audit users. The selected user is not registered as an audit user yet. Would you like to automatically register them as an audit auditor user?',
          autoRegisterLabel: 'Automatically register as an auditor user'
        }
      },
      assignPage: {
        title: 'Assign Auditor',
        subtitle: 'Choose an auditor for this seat. The list shows all identities under the account. Please choose carefully.',
        backToList: 'Back',
        seatInfoTitle: 'Seat Information',
        seatNameLabel: 'Seat Name',
        seatStatusLabel: 'Current Status',
        seatAssigned: 'Assigned',
        seatUnassigned: 'Unassigned',
        loadingSeat: 'Loading seat information',
        seatNotFound: 'Seat not found. Please go back to the list and try again.',
        confirmAssign: 'Confirm Assignment',
        cancel: 'Cancel'
      }
    },
    accountInfo: {
      title: 'Account',
      subtitle: 'View account details and organization information.',
      accountDetails: 'Account Details',
      accountId: 'Account ID',
      accountType: 'Account Type',
      creationTime: 'Creation Time',
      administrator: 'Administrator',
      organizationInfo: 'Organization Information',
      loadError: 'Failed to load account information.',
      accountIdError: 'Unable to retrieve account ID.',
      copied: 'Copied',
      copyFailed: 'Copy failed',
      change: 'change',
      changeAdminTip: 'Please contact customer support to change the account administrator.',
      close: 'Close',
      organization: {
        name: 'Organization Name',
        legalName: 'Legal Name',
        contactEmail: 'Contact Email',
        phoneNumber: 'Phone Number',
        industries: 'Industries',
        taxIdentificationNumber: 'Tax ID',
        legalRepresentative: 'Legal Representative',
        registration: 'Registration',
        registrationNumber: 'Registration Number',
        registrationType: 'Registration Type',
        registrationDocument: 'Registration Document',
        countryOrRegion: 'Country/Region',
        stateOrProvince: 'State/Province',
        city: 'City',
        postalCode: 'Postal Code',
        address: 'Address',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2'
      },
      invoiceInfo: {
        title: 'Invoice Information',
        addButton: 'Add Invoice Information',
        empty: 'No invoice information yet',
        dialogTitleAdd: 'Add Invoice Information',
        dialogTitleEdit: 'Edit Invoice Information',
        fields: {
          title: 'Company Name',
          invoiceType: 'Invoice Type',
          taxId: 'Tax ID',
          address: 'Address',
          phone: 'Phone',
          bankName: 'Bank Name',
          bankAccount: 'Bank Account',
          bankAddresses: 'Bank Addresses'
        },
        addBankAddress: 'Add Bank Address',
        edit: 'Edit',
        default: 'Default',
        setDefault: 'Set as default',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        deleteConfirm: 'Delete this invoice information?',
        loadError: 'Failed to load invoice information.',
        saveSuccess: 'Invoice information saved.',
        deleteSuccess: 'Invoice information deleted.',
        saveFailed: 'Failed to save invoice information.',
        deleteFailed: 'Failed to delete invoice information.',
        titleRequired: 'Please enter the invoice title.'
      }
    }
  },
  newFeatures: {
    title: 'New Features',
    sectionTitle: 'Innovative Audit Solutions',
    sectionSubtitle: 'Empower organizations with cutting-edge audit technology and comprehensive compliance management',
    features: [
      {
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0991d3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>`,
        title: "Intelligent Analytics",
        desc: "Advanced powered analytics to identify risks and anomalies in your audit processes with unprecedented accuracy."
      },
      {
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0991d3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
        title: "Real-time Reporting",
        desc: "Generate comprehensive audit reports in real-time with interactive dashboards and customizable metrics."
      },
      {
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0991d3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
        title: "Compliance Management",
        desc: "Stay compliant with industry standards and regulations through automated monitoring and alert systems."
      },
      {
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#0991d3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
        title: "Collaborative Platform",
        desc: "Enable seamless collaboration between audit teams with integrated communication and workflow management tools."
      }
    ]
  },
  newServices: {
    sectionTitle: 'Professional Audit Services',
    sectionSubtitle: 'Comprehensive audit solutions tailored to your organization\'s unique operation, compliance and risk management needs',
    learnMore: 'Learn More',
    cards: [
      {
        icon: `<img src="/img/3d-icons/financial.png" alt="Financial audit icon" />`,
        title: "Financial   Audit",
        desc: "Optimize your or your suppliers business processes and operational efficiency through detailed operational audits and recommendations."
      },
      {
        icon: `<img src="/img/3d-icons/it-security.png" alt="IT security audit icon" />`,
        title: "IT Security Audit",
        desc: "Thorough assessment of your IT infrastructure, identifying vulnerabilities and ensuring robust cybersecurity measures."
      },
      {
        icon: `<img src="/img/3d-icons/security.png" alt="Compliance audit icon" />`,
        title: "Compliance Audit",
        desc: "Ensure adherence to industry regulations and standards with our specialized compliance audit services."
      },
      {
        icon: `<img src="/img/3d-icons/compliance.png" alt="Operational audit icon" />`,
        title: "Operational Audit",
        desc: "Optimize your business processes and operational efficiency through detailed operational audits and recommendations."
      }
    ]
  },
  home: {
    banner: {
      title: 'Industry Brain Platform',
      description: 'Data-driven intelligence platform connecting government and market, empowering high-quality industrial development',
      title1: 'Next Gen Audit Platform',
      title2: 'Transform your audit process with driven technology and real-time compliance monitoring',
      subtitle1: 'Smart Risk Assessment',
      subtitle2: 'Advanced analytics and machine learning to predict, identify, and mitigate risks before they impact your business',
      button: 'Start Free Trial',
      features: [
        'Powered Audit Analytics',
        'Real-time Compliance Monitoring',
        'Automated Risk Assessment',
        'Comprehensive Reporting Dashboard'
      ]
    },
    carousel: {
      items: [
        {
          kicker: 'AUDIT SOFTWARE',
          description: 'A cleaner way to manage audit templates, standards and execution in one connected workspace.',
          metrics: [
            { value: '12+', label: 'Templates' },
            { value: '1-2Y', label: 'Licensing' },
            { value: 'Cloud', label: 'Delivery' }
          ]
        },
        {
          kicker: 'COMPLIANCE PLATFORM',
          description: 'Designed for modern quality teams that want simpler control, faster collaboration and traceable records.',
          metrics: [
            { value: 'ISO', label: 'Ready' },
            { value: 'Team', label: 'Shared use' },
            { value: 'Live', label: 'Records' }
          ]
        }
      ]
    },
    introduction: {
      title: 'What is Industry Brain',
      subtitle: 'Data-centered, scenario-driven, and service-oriented industrial digital infrastructure'
    },
    sections: {
      government: {
        title: 'Government Side',
        desc: 'Macro monitoring, policy evaluation, industrial profiling, site selection, and precision services'
      },
      market: {
        title: 'Market Side',
        desc: 'Enterprise insights, competitive analysis, investment matching, supply-demand brokerage, and operational enablement'
      }
    },
    coreScenes: {
      title: 'Core Scenarios',
      subtitle: 'From monitoring, evaluation, and mapping to investment, covering the full process'
    },
    advantages: {
      title: 'Our Advantages'
    }
  },
  // Based on advanced technology and standards, our solutions provide you higher integration, more automatization and lean thinking for unparalleled accuracy and efficiency

  news: {
    title: 'News & Updates',
    items: [
      {
        plate: 'Company News',
        title: 'Our Group Achieves Record Growth',
        desc: 'We are proud to announce a remarkable phase of growth for our company.'
      },
      {
        plate: 'New Features / Updates',
        title: 'Automation of several audit steps',
        desc: 'Our new features enhance goal-oriented auditing for individual standards.'
      },
      {
        plate: 'New Templates',
        title: 'More variation leads to more efficiency and effectiveness',
        desc: 'The expansion of our templates allows our customers to cover a wide range of standards.'
      },
      {
        plate: 'Information Security & Data Protection',
        title: 'Information Security and Data Protection through permission management',
        desc: 'Information security and data security is ensured by our software. All information and data of the audit management remains with the organization.'
      },
      {
        plate: 'New ISO 14001',
        title: 'New ISO 14001',
        desc: 'New ISO 14001',
      }
    ]
  },
  growth: {
    title: 'Our Group Achieves Record Growth',
    tags: { innovation: 'Innovation', excellence: 'Excellence', global: 'Global Growth' },
    content: "We're proud to announce a remarkable phase of growth for our company. Over the past months, we've seen significant progress across every area of our business—from expanding our client base and increasing revenue to launching innovative products and scaling our team. This growth is a direct result of the dedication, collaboration, and vision of our incredible team, and the ongoing support from our valued customers and partners."
  },
  automation: {
    title: 'Automation of several audit steps',
    content: 'Our new features enhance goal-oriented auditing concerning the individual standards. An increase in the continuity of audit management enables the auditor to handle the auditing process intuitively and professionally. The automation of several steps in the auditing process, taking into account the Plan-Do-Check-Act (PDCA) approach, allows for significant improvements in audit quality as well as a simplified implementation.'
  },
  variation: {
    title: 'More variation leads to more efficiency and effectiveness',
    content: 'The extension of our templates enables our customers to cover a wide range of standards. The templates were developed with international experts and 3rd party auditors of various standards. This allows for an optimal design of the entire audit software under the principles of Lean Management. A professional audit management is a crucial building block for the success of an organization. The integration of the entire supply chain was taken into account during the development of our audit software. Our software and the individual templates support the increase in effectiveness and efficiency of our customers audit .'
  },
  security: {
    title: 'Information Security and Data Protection through permission management',
    content: 'Information security as well as data security is ensured by our software. All information and data of the audit management remain with the organization. The cloud used is based on TISAX and ISO 2700X standards. A permissions management system controlled by the organization defines access to the stored information and data by other parties. In this way, access can be regulated by the organization so that the information and data always remain within the organizations area.'
  },
  newiso: {
    title: 'New ISO 14001',
    content: 'We are happy to inform you that we can already provide you with the new updated ISO 14001 audit template. Of cause the old audit version of the ISO 14001 will still be available for you. For our existing customers, which have the audit ISO 14001 template, there will be no extra charges and they can use both audit templates.'
  },
  coreCompetence: {
    title: 'Why LPT Technology',
    subtitle: 'Leading the transformation of audit practices through innovation, expertise, and technology',
    technology: {
      title: 'Cutting-edge Tech',
      description: 'Based on advanced technology and standards, our solutions provide you higher integration, more automatization and lean thinking for unparalleled accuracy and efficiency',
      pointsTitle: 'Innovative Audit Management Technology',
      points: [
        'Smart audit automation, significantly improving work efficiency',
        'Precisely identify compliance risks, ensuring robust business operation',
        'Insights based on big data, assisting scientific decision-making',
        'Real-time monitoring of abnormal transactions, warning of potential risks'
      ],
      features: [
        'Financial Services Audit Excellence',
        'Healthcare & Life Sciences Compliance',
        'Manufacturing & Supply Chain Audit',
        'Tech & Software Auditing',
        'Energy & Utilities Compliance',
        'Real Estate & Construction Audit',
        'Retail & E-commerce Audit',
        'Government & Public Sector Audit',
        'Non-profit & NGO Audit'
      ]
    },
    experience: {
      title: 'Expert Experience',
      description: 'Rich European and international audit experience with deep understanding of industry compliance requirements',
      globalDataTitle: 'Global Audit Data Center',
      globalDataDesc: 'Global <span>10000+</span> Official Data Sources <span>10+</span>',
      statistics: [
        { title: '≥10', desc: 'Audit Standards' },
        { title: '20.000+', desc: 'Risk Indicators' },
        { title: '≥12', desc: 'Audit Tools' },
        { title: '55+', desc: 'Countries' },
        { title: '1.000+', desc: 'Clients' },
        { title: '25+', desc: 'Audit Experts' },
        { title: '10.000+', desc: 'Audit Records' },
      ]
    },
    team: {
      title: 'Beyond auditing',
      description: 'International team consisting of senior audit experts and technical specialists',
      upgradeTitle: 'Supporting Intelligent Upgrade of Audit Data',
      capabilities: [
        {
          title: 'Innovative auditing',
          description: 'Go ahead in perspective of auditing by using the digital advantage of our auditmanagement software'
        },
        {
          title: 'Professional Tech Team',
          description: 'Ensuring the continuity of audit management through automated processes'
        },
        {
          title: 'Cover the standard audit requirements with one software',
          description: 'Our software is tested and developed with several international3rd party auditors and companies around the world to cover theequirements of several standards regarding audit management. Get your advantage from these expertise.'
        },
        {
          title: 'More than auditing',
          description: 'Connect your network to the audit management world of your organisation. Set yourown permission requirements for your network accesses.'
        }
      ]
    }
  },
  footer: {
    government: 'Central People\'s Government',
    ministryIndustry: 'Ministry of Industry and Information Technology',
    ministryForeign: 'Ministry of Foreign Affairs',
    products: 'Products',
    audit: 'Audit',
    contentCenter: 'Content Center',
    industryReports: 'Industry Reports',
    contactUs: 'Contact Us',
    cityZhuhai: 'Zhuhai',
    addressDetail: 'Building 02, 21. Etage, Nr. 2103, Meixi Commercial Plaza, 168 Lvyou Road, Xiangzhou District, Zhuhai City, China',
    email: 'Customer Service',
    copyright: 'Copyright © 2026 Lucky Phoenix (Zhuhai) Technology Co. Limited. All rights reserved.',
    icp: '粤 ICP 备 2025411415 号',
    emailHint: 'Please enter your account.'
  },
  //   Lucky Phoenix (Zhuhai) Technology Co. Limited

  // Building 02, 21. Etage, Nr. 2103, Meixi Commercial Plaza, 168 Lvyou Road, Xiangzhou District, Zhuhai City, China

  // 幸运丹鸟（珠海）科技有限公司

  // 珠海市香洲区旅游路168号梅溪商业广场2栋21层2103号
  company: {
    name: "Lucky Phoenix Technology",
    fullName: 'Lucky Phoenix (Zhuhai) Technology Co., Ltd.',
    description: 'A leading technology enterprise, focusing on providing innovative audit and management system solutions including services for local and global organizations',
    tagline: 'Intelligent Audit, Compliant Future',
    aboutUs: 'About Us',
    subtitle: 'Driving innovation in audit management technology.',
    missionTitle: 'Our Mission',
    missionDesc: 'To empower organizations worldwide with intelligent, secure, and efficient audit management solutions.',
    visionTitle: 'Our Vision',
    visionDesc: 'Becoming the global standard for digital audit compliance and risk management.',
    galleryTitle: 'Life at LPT',
    galleryDesc: 'A glimpse into our workspace, team culture, and daily operations.',
    whoWeAre: 'Who We Are',
    introText: 'LPT is committed to providing cutting-edge audit management solutions tailored for global enterprises.',
    ourHistory: 'Our History',
    history: {
      events: [
        'Founded in the new technology business zone of Zhuhai',
        'Start at the office in Zhuhai Hengqin new business Technology area',
        'Our first software launch in China',
        'Our software launch in other areas of Asia',
        'Launch of additional audit tools',
        'Launch of our new software project',
        'We are proud that our growth and success leads us to a new office with new technology laboratory in the heart of Zhuhai City.',
        'Introduction of our new software management platform',
        'Future awaits'
      ]
    },
    joinUsTitle: 'Join Our Team',
    joinUsDesc: 'Discover your potential and grow with us. We are always looking for passionate talents to join our dynamic team.',
    exploreJobs: 'Explore Open Positions',
    customersTitle: 'Our customers',
    customersDescription: 'Continuously creating unique value for our users',
    customerStats: {
      provinceCount: '22', cityCount: '40+', parkCount: '150+', companyCount: '10,000+',
      provinces: 'Provinces', cities: 'Cities', parks: 'Industrial parks', companies: 'Companies'
    }
  },
  jobs: {
    title: 'Open Job Positions',
    intro: 'LPT Company is part of the global Infinity Source Group. Due to our membership, we have access to a wide range of resources. LPT is headquartered in the heart of Zhuhai City, China. Its business areas cover applications and software, as well as proactive consulting with a focus on the IT industry. LPT is building a professional and dynamic new type of team. We rely on innovative and visionary working methods.',
    advantagesTitle: 'What advantages do we offer you as member of our team:',
    advantages: [
      'You can work in the office or from around the world (there is no fixed working area)',
      'Access to the newest technology and equipment',
      'Various bonus schemes',
      'Free water in the office',
      'Above-average number of vacation days',
      'Free access to our Gaming Area in the office',
      'Work with an ambitious, professional and open-minded team',
      'Open, dynamic and professional work environment',
      'Full-paid work equipment for your home and at work',
      'Innovative and forward-looking projects'
    ],
    positionsTitle: 'Current Openings',
    positions: [
      {
        title: 'UX/Interaction Designer',
        overview: 'Responsible for UI design for Web, App, and H5',
        expectTitle: 'What we expect:',
        expectations: [
          'Open and goal-oriented communication',
          'Work independently and professionally',
          'Be open minded to new solutions and challenges',
          'Chinese language proficiency',
          'Written English communication (using translation software is sufficient)',
          'Experience in Human-Computer Interaction (HCI) design',
          'Use design language to improve design and interaction',
          'Experience in providing high-quality solutions in application, software and web design',
          'Design experience ability, able to effectively convey product intentions through design solutions',
          'More than 2 years of experience as a UX designer or interaction designer'
        ],
        softwareTitle: 'Familiar with design-related software and platforms, such as:',
        software: ['Lanhu', 'Figma', 'Photoshop', 'Illustrator', 'Azure', 'Sketch', 'InVision', 'XMIND', 'Visio', 'or similar'],
        responsibilitiesTitle: '',
        responsibilities: []
      },
      {
        title: 'Marketing Specialist',
        overview: 'We are looking for a marketing specialist',
        expectTitle: 'What we expect:',
        expectations: [
          'Open and goal-oriented communication',
          'Work independently and professionally',
          'Be open minded to new solutions and challenges',
          'Chinese language proficiency',
          'Written English communication (using translation software is sufficient)',
          'Experience in technology marketing',
          'Experience with social media',
          'Experience in providing high-quality marketing solutions including social media',
          'Open to travelling (if relevant)',
          'More than 2 years of experience in marketing'
        ],
        softwareTitle: '',
        software: [],
        responsibilitiesTitle: 'Responsible for the web and social media appearance:',
        responsibilities: [
          'Marketing related web design',
          'Social media appearance',
          'Marketing events'
        ]
      },
      {
        title: 'Backend Developer',
        overview: 'We are looking for a software developer',
        expectTitle: 'What we expect:',
        expectations: [
          'Open and goal-oriented communication',
          'Work independently and professionally',
          'Be open minded to new solutions and challenges',
          'Chinese language proficiency',
          'Written English communication (using translation software is sufficient)',
          'Experience in providing high-quality backend solutions in application and software',
          'More than 2 years of experience as a backend developer',
          'Familiar with RESTful API design patterns and best practices',
          'Experience with version control and code review processes',
          'Strong problem-solving skills and attention to detail'
        ],
        softwareTitle: 'If you have skills in some of the areas mentioned or in similar, then you are in the right place.',
        software: [
          'Backend APIs (Application Programming Interfaces)',
          'VUE',
          'MySQL',
          'Nginx',
          'MyBatis',
          'JavaScript',
          'Docker',
          'GitHub, GitLab',
          'PHPStorm or WebStorm',
          'Postman',
          'JSON',
          'Laravel 9 or similar',
          'PHP 8 or similar',
          'Progressive Web Applications',
          'Data Structures and Algorithms (DSA)',
          'Azure Cloud or Alibaba Cloud experience'
        ],
        responsibilitiesTitle: 'Responsible for:',
        responsibilities: [
          'Backend infrastructure',
          'Interface between backend and frontend Cloud development',
          'Backend framework',
          'API development and integration',
          'Database'
        ]
      },
      {
        title: 'Frontend Developer',
        overview: 'We are looking for a software developer',
        expectTitle: 'What we expect:',
        expectations: [
          'Open and goal-oriented communication',
          'Work independently and professionally',
          'Be open minded to new solutions and challenges',
          'Chinese language proficiency',
          'Written English communication (using translation software is sufficient)',
          'Experience in providing high-quality frontend solutions in application and software',
          'More than 2 years of experience as a frontend developer',
          'Familiar with modern web standards, accessibility and responsive design',
          'Experience with version control and code review processes',
          'Strong problem-solving skills and attention to detail'
        ],
        softwareTitle: 'If you have skills in some of the areas mentioned or in similar, then you are in the right place.',
        software: [
          'HTML',
          'JavaScript',
          'GitLab repository',
          'GitLab CI/CD automated deployment',
          'React',
          'Angular',
          'Document Object Model (DOM)',
          'Jest, Mocha or similar',
          'CSS',
          'Vue',
          'Azure Cloud or Alibaba Cloud experience'
        ],
        responsibilitiesTitle: 'Responsible for:',
        responsibilities: [
          'Frontend infrastructure',
          'Interface between frontend and backend',
          'Cloud development',
          'Frontend framework',
          'API development and integration',
          'Database'
        ]
      }
    ],
    applyNow: 'Submit Application'
  },
  buy: {
    hero: {
      title: 'Audit Management Solution',
      subtitle: 'Overview of your audit management solution for more flexibility, more automatization and higher efficiency..'
    },
    steps: {
      badge: {
        step1: 'Step 1 / 6',
        step2: 'Step 2 / 6',
        step3: 'Step 3 / 6',
        step4: 'Step 4 / 6',
        step5: 'Step 5 / 6',
        step6: 'Step 6 / 6'
      },
      plan: { title: 'Select package', subtitle: 'Choose your subscription' },
      languages: { title: 'Select language', subtitle: 'Choose audit system languages' },
      standards: { title: 'Audit Standards', subtitle: 'Select templates' },
      seats: { title: 'Auditor licences', subtitle: 'Configure team size' },
      confirm: { title: 'Review Order', subtitle: 'Check and pay' },
      payment: { title: 'Payment', subtitle: 'Complete purchase' }
    },
    nav: {
      prev: 'Previous',
      next: 'Next',
      completePurchase: 'Complete Purchase',
      processing: 'Processing...',
      purchaseSuccess: 'Purchase successful!',
      purchaseError: 'Purchase failed. Please try again.'
    },
    trust: {
      secure: '256-bit SSL encryption',
      moneyBack: '30-day money-back guarantee',
      support: '24/7 expert support',
      cancel: 'Cancel anytime'
    },
    currency: {
      label: 'Currency'
    },
    summary: {
      projectSummary: 'Project Summary',
      priceSummary: 'Price Summary',
      selectedPlan: 'Selected Plan',
      billingCycle: 'Subscription',
      year1: '1 Year',
      year2: '2 Years',
      year3: '3 Years',
      selectedLanguages: 'Languages',
      selectedStandards: 'Standards',
      auditorSeats: 'Auditor licences',
      adminSeats: 'Admin Seats',
      supplierSeats: 'Supplier licences',
      unlimited: 'Unlimited',
      estimatedTotal: 'Estimated Total',
      amountToPay: 'Amount to Pay'
    },
    languages: {
      title: 'Select Languages',
      subtitle: 'Choose the audit system languages included in your package.',
      selectedCount: '{count} languages selected',
      limitCount: 'Up to {count} languages',
      limitUnlimited: 'Unlimited languages',
      infoLimited: 'This package includes up to {count} languages. You can change the selection before payment.',
      infoUnlimited: 'Enterprise Package includes all available audit system languages.',
      limitReached: 'This package allows up to {count} languages.',
      minimumRequired: 'Please keep at least one language selected.',
      items: {
        english: 'English',
        french: 'French',
        spanish: 'Spanish',
        chinese: 'Chinese',
        german: 'German',
        polish: 'Polish',
        czech: 'Czech',
        slovak: 'Slovak',
        hungarian: 'Hungarian',
        romanian: 'Romanian',
        bulgarian: 'Bulgarian',
        serbian: 'Serbian',
        croatian: 'Croatian',
        slovenian: 'Slovenian'
      }
    },
    plan: {
      monthly: '1 year',
      yearly: '2 years',
      perMonth: 'year',
      perYear: '2 years',
      savePercent: 'Save {percent}%',
      billedAnnually: 'Billed annually',
      billedForTwoYears: 'Billed for 2 years',
      mostPopular: 'Most Popular',
      selectPlan: 'Select Plan',
      selected: 'Selected',
      compareFeatures: 'Compare all features',
      feature: 'Feature',
      noPlans: 'No plans available',
      plans: {
        starter: {
          name: 'Starter Package',
          desc: 'Perfect for small teams starting with formalized auditing.',
          features: [
            '1 auditor licence',
            'Multiple audit templates',
            'Supplier portal access',
            'One language',
            'Online/offline mode',
            'Risk assessment',
            'SSO & Advanced Security'
          ]
        },
        professional: {
          name: 'Professional Package',
          desc: 'For growing organizations with advanced audit needs.',
          features: [
            'Multiple auditor licences',
            'Multiple audit templates',
            'Supplier portal access',
            'Two languages',
            'Enterprise reporting',
            'Online/offline mode',
            'Risk assessment',
            'SSO & Advanced Security'
          ]
        },
        enterprise: {
          name: 'Enterprise Package',
          desc: 'Complete audit governance for large organizations.',
          features: [
            'Multiple auditor licences',
            'Multiple audit templates',
            'Supplier portal access',
            'Multiple languages',
            'Enterprise reporting',
            'Enterprise support',
            'Online/offline mode',
            'Risk assessment',
            'SSO & Advanced Security'
          ]
        }
      },
      comparison: {
        auditorSeats: 'Multiple auditor licences',
        auditStandards: 'Multiple audit templates',
        supplierPortal: 'Supplier portal access',
        customTemplates: 'Multiple languages',
        aiRiskAssessment: 'Enterprise reporting',
        apiAccess: 'Enterprise support',
        ssoIntegration: 'Online/offline mode',
        dedicatedSupport: 'Dedicated support',
        dataRetention: 'Data retention',
        storage: 'Cloud storage',
        clientSupper: "Client portal access",
        ssl: "SSL encryption"
      },
      comparisonValues: {
        unlimited: 'Unlimited',
        sixMonths: '6 Months',
        oneYear: '1 Year'
      }
    },
    standards: {
      perYear: "Year",
      title: 'Select Audit Standards',
      subtitle: 'Choose the audit standard templates, which fits best to your organization needs',
      categories: {
        all: 'All',
        quality: 'Quality',
        energy: 'Energy',
        product: 'Product',
        environment: 'Environment',
        process: 'Process',
        security: 'Information Security',
        medical: 'Medical',
        healthSafety: 'Health/Safety',
        creator: 'Creator'
      },
      selectedCount: '{count} standards selected',
      moduleCost: 'Module cost',
      perMonth: 'month',
      included: 'Included',
      free: 'Free',
      clauses: 'clauses',
      infoBanner: 'You can purchase additional standards, languages, and licences later in your console.',
      items: {
        iso9001: {
          fullname: 'Quality Management Systems (ISO 9001)',
          desc: 'Systemic evaluation of the quality management system for all sectors and industries'
        },
        iatf16949: {
          fullname: 'Automotive Quality Management System (IATF 16949)',
          desc: 'Systemic evaluation of the quality management system in the automotive industry'
        },
        vda63: {
          fullname: 'Process Audit (VDA 6.3)',
          desc: 'Process evaluation procedure for all sectors and industries'
        },
        vda65: {
          fullname: 'Product Audit (VDA 6.5)',
          desc: 'Systematic evaluation of manufactured products quality standard.'
        },
        iso14001: {
          fullname: 'Environmental Management (ISO 14001)',
          desc: 'Systemic evaluation of the environmental management system'
        },
        iso140012026: {
          fullname: 'Environmental Management (ISO 14001)',
          desc: 'Systemic evaluation of the environmental management system'
        },
        iso45001: {
          fullname: 'Occupational Health & Safety (ISO 45001)',
          desc: 'Systemic evaluation of the environmental management system'
        },
        iso27001: {
          fullname: 'Information Security (ISO 27001)',
          desc: 'Systemic evaluation of the information security management system'
        },
        tisax: {
          fullname: 'Information Security (TISAX ISA)',
          desc: 'Systemic evaluation of the information security management system'
        },
        iso13485: {
          fullname: 'Medical Management(ISO 13485)',
          desc: 'Systemic evaluation of the medical management system'
        },
        iso50001: {
          fullname: 'Energy (ISO 50001)',
          desc: 'Systemic evaluation of the energy management system'
        },
        'ISO-9001-2015': {
          fullname: 'Quality Management Systems (ISO 9001)',
          desc: 'Systemic evaluation of the quality management system'
        },
        'ISO-14001-2026': {
          fullname: 'Environmental Management (ISO 14001)',
          desc: 'Systemic evaluation of the environmental management system'
        },
        'ISO-13485-2016': {
          fullname: 'Medical Devices Management (ISO 13485)',
          desc: 'Systemic evaluation of the medical device quality management system'
        },
        'ISO-45001-2018': {
          fullname: 'Occupational Health & Safety (ISO 45001)',
          desc: 'Systemic evaluation of the occupational health and safety management system'
        },
        'ISO-50001-2018': {
          fullname: 'Energy (ISO 50001)',
          desc: 'Systemic evaluation of the energy management system'
        },
        'ISO-27001-2023': {
          fullname: 'Information Security (ISO 27001)',
          desc: 'Systemic evaluation of the information security management system'
        },
        'ISO-14971-2019': {
          fullname: 'Medical Device Risk Management (ISO 14971)',
          desc: 'Systemic evaluation of the risk management process for medical devices'
        },
        'ISO-22163-2023': {
          fullname: 'Railway Quality Management System (ISO 22163)',
          desc: 'Systemic evaluation of the quality management system in the railway sector'
        },
        'ISO-31000-2018': {
          fullname: 'Risk Management (ISO 31000)',
          desc: 'Systemic evaluation of the risk management framework and process'
        },
        customTemplate: {
          fullname: 'Custom Template Creator',
          desc: 'Build your own audit templates with flexible checklist configuration and custom scoring.'
        }
      }
    },
    licences: {
      title: 'Configurate Auditor Licences',
      subtitle: 'Set the number for your auditor team',
      perSeatYear: 'licences/year',
      perYear: 'year',
      perMonth: 'month',
      totalSeats: 'Total users',
      users: 'users',
      seatsCost: 'Auditor licences',
      contactMore: 'Contact us for more',
      auditor: {
        title: 'Auditor licences',
        desc: 'Licensed users who perform audits, create findings, and generate reports',
        seats: 'licences'
      },
      admin: {
        title: 'Additional auditor licences',
        desc: 'Licensed users who perform audits, create findings, and generate reports',
        includedCount: '{count} licences included in plan',
        extraSeats: 'extra licences',
        extraLabel: 'Additional auditor licences:'
      },
      supplier: {
        title: 'Supplier portal',
        desc: 'Unlimited supplier access included in all packages at no extra cost',
        unlimited: 'Unlimited access',
        note: 'Supplier activities',
        features: [
          'View audits',
          'Upload files and evidence',
          'Manage Action Management',
          'Receive notifications'
        ]
      },
      client: {
        title: 'Client portal',
        desc: 'Unlimited client access included in all packages at no extra cost',
        unlimited: 'Unlimited access',
        note: 'Clients can view audit reports, track progress, and manage compliance documents',
        features: [
          'Client activities',
          'Track audit progress',
          'View audits',
          'Manage shared documents'
        ]
      },
      planChangePrompt: 'Please change the plan to modify this'
    },
    order: {
      title: 'Review your order',
      subtitle: 'Check your selections before completing purchase',
      planDetails: 'Audit package',
      selectedPlan: 'Selected package',
      billingCycle: 'Billing cycle',
      planPrice: 'Price',
      package: "Package",
      languagesDetails: 'Languages',
      standardsDetails: 'Audit standard templates',
      seatsDetails: 'Licences  configuration',
      seatsPrice: 'Auditor licences',
      standardsPrice: 'Audit template',
      promoPlaceholder: 'Enter promo code',
      applyPromo: 'Apply',
      promoApplied: '{discount}% discount applied!',
      promoSuccess: 'Promo code applied successfully!',
      promoInvalid: 'Invalid promo code',
      promoDiscount: 'Promo discount',
      orderSummary: 'Order summary',
      totalMonthly: 'Total',
      vatNote: '* Prices exclude VAT',
      agreePrefix: 'I agree to the',
      termsOfService: 'Terms and Conditions',
      agreeAnd: 'and',
      privacyPolicy: 'Privacy Policy',
      agreementRequired: 'Please read and agree to the Terms and Conditions and Privacy Policy to complete your purchase',
      encrypted: 'Encrypted',
      sslEncrypted: 'SSL encrypted',
      licenceCount: 'No licences | {count} licence | {count} licences',
      guarantee: '30-day money-back guarantee',
      storage: {
        title: 'Storage',
        desc: 'Storage and volume.',
        included: 'Included',
        free: 'Free',
        excluded: 'Excluded',
        payAsYouGo: 'Pay on demand'
      },
      termsContent: [
        '幸运丹鸟（珠海）科技有限公司  Agreements, terms and conditions',
        'Agreements, terms and conditions of the company lpt ‚private limited liability company‘we welcome you to our web site, facilities, platforms, softwares, applications and others. Lpt (hereinafter called ‚lpt‘ ‚幸运丹鸟（珠海）科技有限公司‘) and its affiliates (together, ‚we‘, ‚our‘ or ‚us‘). These agreements, terms and conditions applicationslies to this web site, to any software or applicationslication of us, any web site of us or us at third-party web sites, softwares and applications (online or offline), but does not applicationsly to any other product or service of us, unless otherwise explicit expressly indicated by us (such as by including a link to these agreements, terms and conditions on other web sites, softwares of us or on mobile applications of us).Agreements, terms and conditions as amended on 01.04.2026important – please read these agreements, terms and conditions carefully before accepting these agreements, then save these agreements, terms and conditions and store them along with all confirmation emails, sms messages, messages, additional terms, privacy policy, other policies, others; etc. Relevant to your use of the platforms and/or facilities and/or softwares and/or applications. We will not file our contract with you so please save it for your records. These agreements, terms and conditions are subject to change (as set out below).You accept to be bound by this contract by clicking on ‚sign up‘ or ‚sign in‘ or \'submit\' or \'agree\' or any other and/or by using the facilities (as that term is hereinafter defined). After you (as that term is hereinafter defined) click on \'submit\' or \'i agree\' or when you use the facilities, a legally binding agreement on these agreements, terms and conditions is concluded between, (a) you, the end user (\'you\') and (b) 幸运丹鸟（珠海）科技有限公司 registered with companies registry under no. 91440400macd90me4a, with registered address at building 02, 21. Etage, nr. 2103, meixi commercial plaza, 168 lvyou road, xiangzhou district, zhuhai city. Lpt is defined as \'we\', \'us\' or \'our\' as appropriate. We shall be deemed to be regulated by the law of china.We provide facilities at the websites, softwares and/or applications, and any other online or mobile platform provided by us (each individual site being a \'platform\') on which you access our, facilities, as defined below using your account (facilities\').In the event that you have any complaints, claims or disputes with regard to any outcome regarding the facilities or any other activity performed by us, you should in the first instance contact us in accordance with and in our agreements, terms and conditions.',
        'These agreements, terms and conditions together with the privacy policy, all additional rules or policies and any other additional rules, policies, terms and others published on the platforms and/or softwares and/or applications and notified to you on the platforms, websites, softwares or applicationss that specifically relate to and govern any particular event, software, promotion or others constitute a legally binding agreement between you and us (\'agreements\'). Upon notification of any change to the rules or terms of the agreements to you, you shall have the option to terminate in accordance with and in our agreements, terms and conditions. You should read all of these documents carefully as each one forms part of the legally binding agreement between you and us.If these agreements are translated into another language, the chinese language version will prevail in the event of any conflict between the translation and the other language version.Please note that these agreements, terms and conditions shall prevail in the event of any conflict between these agreements, terms and conditions and other documents referred to in these agreements, terms and conditions.By clicking on ‚sign up‘ or ‚sign in‘ or \'submit\' or \'agree\' or any other and accepting these agreements, terms and conditions, you are also acknowledging and accepting these agreements. Access to and use of our facilities are governed by these agreements. If you have any questions about these agreements, we would encourage you to seek independent legal advice.The facilities and interactive features may vary according to the platform or software or applications or others you are using to access them from.Your attention is drawn to our privacy policy which describes how we deal with and protect your personal information. By accepting these agreements, terms and conditions, you are also acknowledging and accepting the privacy policy and all others.Software, applicationslication or website facilitiesthe software, applications or website facilities are the facilities provided by us via the following platforms such as (but not limited to): lpt-software.Cn and any other platforms and/or softwares and/or applications provided by us from time to time.If you are using or intending to use the softwares, applications or website facilities, you must do so in accordance with and in our agreements, terms and conditions.',
        'Contractual basiswe do not recognize any customer conditions that conflict with or deviate from our general terms and conditions unless we have expressly agreed to their validity in writing. The tacit provision of deliveries or services or similar on our part does not imply agreement with the customer\'s conflicting conditions. The legal transaction (delivery, billing, etc.) Is carried out by lpt in its own name for the account of third parties.Order and conclusion of contractthe presentation of the products, software, applications or the like in the online shop does not represent a legally binding offer on our part, but rather a non-binding online catalog (hereinafter referred to as the order offer). The customer can first place the products, software, applications or similar from the online shop in the shopping cart without obligation and make the entries before submitting the order correct at any time. By clicking the “buy” button, the customer places a binding (payable) order (offer) for the goods, software, applications or similar contained in the shopping cart. Confirmation of receipt of the order follows after sending the order and does not constitute acceptance of the contract. We can accept the customer\'s order by sending a confirmation or otherwise within 10 working days. We only accept the usage of our goods, software, applications or similar for business and not private usage. The conclusion of a contract by the consumer is hereby rejected. Consumer protection regulations do not apply. The contract will not be saved.Deliveryif available, the ordered products, software, applications, books or similar, will be delivered immediately (within applicationsroximately 10 working days), offered for download or the corresponding online access made available. We reserve the right to refrain from executing an order if the product, software, applications or similar is no longer in stock, out of stock or available or is otherwise prevented. In this case, the customer will be informed of the unavailability.Updateif corresponding services, products, software, applications or the like are made available by lpt that include the update, these can be made available either for a fee or at no cost. These do not contain any claim to correctness or completeness and do not represent a binding, legal or comparable obligation for lpt.',
        'Third party providersthe customer sometimes has the opportunity to access content from third parties. For this purpose, it may be redirected to servers, clouds or similar of these third-party providers. If additional costs arise for the third-party content (e.G. Pay per document or similar), the customer will be informed of this by the third-party provider. If this information is not provided by the third party, the customer cannot assert any legal or comparable claim against lpt. In case the customer uses our our services, products, websites, software, applications or similar as saas then withunder the chapter ‘saas (software as a service)’ applies. Viewing period / test phaseif a viewing period/test phase is offered or specified, the customer has an offer-dependent viewing period/test phase when purchasing for the first time. The right to test begins on the day of the order. If the customer decides to use the software long-term, he can continue working directly with all the data entered, if explicitly mentioned. With the order he receives the invoice within his registered account. This will only be due after the end of the test period. If the customer decides against lpt\'s service, software, applications or similar, it will automatically be deactivated or similar after the viewing period/test phase has expired.Prices and payment termspricesthe prices in our online shop, websites, software, applications or similar are net prices plus statutory tax and any shipping costs incurred. The costs for the usage of the third-party services (for example but not limited to saas etc.) Are not included in our prices and the customer will be charged separately. The total price including tax and shipping costs is displayed to the customer on the order overview page (shopping cart) before placing the order. If offered by lpt, the customer has the option of choosing between different payment methods in the shopping cart. Payment is due when the contract is concluded.Payment methods and due dateswe offer various payment methods that can be selected by the customer. The respective due dates are specified or are based on the respective legal provisions. An order, invoices and reminders will be sent to the customer accordingly (for example, but not limited to, email, in the account or similar).',
        'Delay in payment and blocking of accessin the event of late payment, lpt is entitled to block, delete or similar access to our services, products, websites, software, applications or similar. The lpt does not have a specified period of time for blocking or deleting. In this case, the customer remains obliged to pay the agreed prices. In this case, lpt is entitled to demand payment of the entire agreed annual amount and to hand over the outstanding claims to a debt collection agency or similar for prosecution. In particular, the customer must bear the costs incurred by the debt collection service provider or similar. If access is blocked, deleted or similar to services by lpt for reasons for which the customer is responsible, the customer must bear the costs of the blocking, the costs of late payment and similar costs. Furthermore, in this case, the customer has no right or claim to invoice lpt for any incurred or possible costs or comparable costs of any kind. In this case, we reserve the right to permanently deny or block the customer\'s access to or use of our services, products, websites, software, applications or similar and to delete their account (immediately). If the lpt\'s decision states that the blocking, blockade or similar will be lifted once the outstanding claims have been settled, this lifting may take a few working days.Price adjustment and other adjustmentswe are entitled to carry out and make adjustments to costs, prices, offers and similar items during the term of the contract. These adjustments will be communicated to the customer for example via email, web sites, accounts, software, applications or similar. The notice periods remain unaffected by this.Right of retentionthe customer is not entitled to withhold payments unless he is entitled to a statutory right of retention from the same contractual relationship. Offsetting is only permitted if the claim being offset is undisputed or has been legally established. Costs for unauthorized return debits must be borne by the customer.Delivery costsif costs arise for deliveries, these will be charged to the customer in the order and must be borne by the customer. These costs may vary depending on the delivery method and delivery.Contract term and terminationcontract terma minimum contract period is agreed upon in the subscriptions, packages, services, products, software, applications or similar. Unless termination is declared, the contract is automatically extended.',
        'Terminationin the case of subscriptions, packages, services, products, software, applications or similar, termination of the contract is possible with effect at the end of the term, unless the contract contains a specifically agreed notice period. Termination can be declared up to the last day of the term. Any deliveries still received after the termination of the contract must be returned. After the end of the contract, lpt has no obligation to save or retain data, information or anything similar. By terminating the contract, the customer releases lpt from any obligation of storage, archiving or similar. The customer also authorizes lpt to carry out any type of deletion.Form of terminationany type of termination must be made in writing using the type/form of termination specified by lpt. In most cases this is done using a form.Termination for important reasonthe right of both parties to terminate for good cause remains unaffected. In particular, we are entitled to terminate this contract extraordinarily without notice if:the customer is in arrears with the payment of an amount for a period of time,the user account was transferred or the access data was made accessible to third parties without our prior consent orthe customer has breached their other obligations under this contract. The extent to which a deadline with a threat of rejection of the breach of contract is necessary depends on the applicable law. If this is not regulated by law, lpt has the right to extraordinary termination immediately without setting a deadline.My account and accessmy accountthe registered customer can carry out all activities themselves via the customer account. This serves the customer, among other things, to purchase services, software, products, applications or similar.Registrationthe use of the customer account requires registration. The registration of a legal entity may only be carried out by an authorized natural person who must be named. We can refuse to accept registrations if there is an objective reason for doing so, e.G. Incorrect information is provided or there is a fear that payment obligations will probably not be met. We also reserve the right to reject registration without giving reasons.',
        'Copyright and trademarksthe terms lpt-logo and any other marks used by the lpt are the trademarks, service marks and/or trade names of the lpt or one of its subsidiaries or associated companies or its licensors. Further, all other material used by lpt, including but not limited to the softwares, images, pictures, graphics, photographs, animations, videos, music, audio, text (and any intellectual property rights in and to any of the same) is owned by the lpt or one of its subsidiaries or associated lpt companies and/or licensors and is protected by copyright and/or other intellectual property rights. You obtain no rights in such copyright material or trade or service marks and must not use them without the lpt\'s written permission.Copyright / usage rightsscope of usage rightscustomers are only granted non-transferable and non-exclusive usage rights to our service, websites, software, products, applications or similar for a limited period of time for the duration of the agreed term of the usage contract. The right of use is limited to the use described below.Service, web sites, softwares, products, applicationslikations or similarscope of rights to use (usage rights)the customer has the right to use our service, websites, software, products, applications or similar to the extent agreed in the contract (number of licenses purchased, duration of the right of use). Our services, websites, software, products, applications or similar may only be installed once per license and used by one person. In the case of a contract for a network version/multiple licenses, the customer is entitled to use our services, websites, software, products, applications or similar by a number of people corresponding to the number of licenses purchased. The duration of the right of use is determined by the respective offer.',
        'Saas (software-as-a-service)we also use saas in some of our service, websites, software, products, applications or similar. Therefore, the customer is responsible to ensure compatible access and required hardware and software environment. The storage of data and information can be on third-party providers. By using our service, websites, software, products, applications or similar the customer accepts the terms and conditions by those third-party providers. The customer is responsible to view those terms and conditions before using our service, websites, software, products, applications or similar. The costs for the usage of the third-party services are defined withunder in the chapter ‘prices and payment terms’. In case of failures or similar the customer is required to share this information directly with our customer service. For more details see withunder the chapter ‘handover point and availability’ and ‘service level and support’.The customer may only use the services covered by the contract in accordance with the contract. Only data that is free of computer viruses or other harmful code may be transmitted. Neither the software nor any other techniques or methods related to the use of the saas solution may be used in a way that could impair its operation, security, or availability. Lexware office is accessible via standard web browsers. If you use additional technologies such as add-ons, plug-ins, vpns, or similar, this may result in lexware office being unavailable or only partially available. In such cases, we assume no liability for availability. The use of interfaces that are not offered via the public api or partner api and are undocumented is prohibited. The customer will only use the services covered by the contract to the extent contractually agreed and in compliance with the applicable guidelines (terms and conditions).The liability of lpt in case the customer uses the saas solutions. The lpt liability per calendar year is limited to foreseeable damages at the time of contract conclusion, up to a total amount for all claims per calendar year equal to 60% of the remuneration paid by the customer in that calendar year. This limitation of liability also applies in the event of data loss or data corruption.',
        'Contractual use of ai (artificial intelligence) functions or aiif an ai function is implemented by lp, the customer is authorized to use this ai without violating any applicable legal or regulatory requirements. Furthermore, the usage of the ai function is only permitted in the context and in compliance with our terms and conditions. The use of ai that poses a risk is strictly prohibited. No distinction is made regarding the type of risk. Content filters or security systems that are part of the ai ​​functions may not be deactivated, circumvented, disrupted, or impaired by the customer. This also includes direct or indirect prompt injection or adversarial inputs. Furthermore, the customer is aware that the output does not constitute legal advice in individual cases and does not replace advice from persons of the relevant profession (for example but not limited to, audit experts, tax advisors, lawyers etc.). The results and consequences of using ai are entirely the responsibility of the customer. Lpt is in no way liable or responsible for the use, consequences, or results arising from the application of ai. This also includes the requirements and regulations regarding the applicable data protection laws, property rights and similiar. The customer shall indemnify and hold us harmless from all third-party claims (including those of its users) upon first demand, arising from its use of the ai ​​functions or their use by its authorized users. This includes court and legal fees. The customer has no claim to legal or other compensation against lpt.Purpose of usethe customer is entitled to use our service, websites, software, products, applications or similar exclusively for their own purposes. The free or paid use of our services, websites, software, products, applications or similar on behalf of third parties and passing them on to third parties is not permitted.',
        'Number of installationsthe authorization is limited to the fact that the selected service(s), websites, software, products, applications or similar can be used to the extent described by us. The customer is not entitled to install, reproduce or compare our services, websites, software, products, applications or similar on their devices or similar to a wider extent. Any duplication or misuse for comparable purposes will result in criminal and legal consequences. Furthermore, the customer may not reproduce the service, web sites, software, products, applications or comparable items or components thereof, the images supplied, the manual, accompanying texts or similar items or the associated documentation by photocopying or microfilming, electronic backup or any other method used by the service , web sites, software, products, applications or similar products, and/or the associated documentation, shall not be distributed, rented, granted sub-licenses to third parties or made available to third parties in any other way. The customer is not entitled to use access codes and/or passwords as well as other information, data or comparable items for the service, web sites, software, products, applications or similar or for database access that is connected to the service, web sites, software, products, applications or comparable items in connection with this will be passed on to third parties. The customer is not authorized to change, modify, adapt, decompile or similar the service, websites, software, products, applications or similar and/or the associated documentation in whole or in part.Copyright and similar',
        'copyrightthe information banks, databases, clouds and comparables (online and offline) for our services, websites, software, products, applications or similar are protected by copyright. In addition, the contents such as, but not limited to, checklists, documents, documented information and similar items are protected by copyright. Our services, websites, software, products, applications or similar are protected by copyright and are subject to the respective copyright law. The customer is entitled to use them for business purposes for the defined purposes. If the actual use unreasonably impairs our legitimate interests or we suspect this, we are entitled to restrict or prevent access. This applies in particular to the reproduction, distribution or public reproduction of essential components or the repeated and systematic reproduction, distribution or public reproduction and making accessible to our services, websites, software, products, applications or comparable components as well as to insignificant components thereof. All copyrights, usage rights and other intellectual property rights to the information banks, databases, clouds and similar (online and offline) for our services, websites, software, products, applications or similar not expressly listed below remain with us as the owner of all usage and property rights.Scope of right to use (usage rights)the customer acquires the right to access the information banks, databases, clouds and similar (online and offline) for our service, websites, software, products, applications or similar, which are used for these purposes and in compliance with the agreed regulations, guidelines and agreements suitable is. The duration of the right of use is determined by the agreement underlying the contractual relationship.',
        'Limitations of usagethe customer undertakes to use the information banks, databases, clouds and comparables (online and offline) for our services, websites, software, products, applications or comparables only for their own purposes and not to grant third-parties separate access to them, either free of charge or for a fee to enable the information banks, databases, clouds and similar things (online and offline) for our services, websites, software, products, applications or similar. The information banks, databases, clouds and comparables (online and offline) for our services, websites, software, products, applications or comparables may only be used by one person or the number of people defined by lpt per license. The customer undertakes not to reproduce, modify, adapt or make available to third-parties information, data or comparable information, data or comparable information, web sites, software, products, applications or comparable information without our written consent in full, in part or comparable form, so that they can gain access, without being licensed users (indirect use). Furthermore, any transfer of information, data or comparable items to third parties that is not within the scope of the service, websites, software, products, applications or similar used is not permitted without our written consent.Restrictions on useuse is only permitted on the services, websites, software, products, applications or similar that we support. The customer is prohibited from changing copyright notices, marks, trademarks and/or ownership information on the service, web sites, software, products, applications or similar items.Warrantyright to updateour services, websites, software, products, applications or similar are regularly created, revised and updated with the expected care. Despite all caution and care, when using the service, websites, software, products, applications or comparable items, it should always be ensured that a change in the law or other changes may make a modification or similar necessary. Complaints must be submitted immediately in writing to lpt (customer service). The customer is not entitled to any compensation from lpt in this regard.Right to remedythe customer can request repairs within the statutory warranty period. If we are not willing or able to carry out repairs or something similar, or if this fails for other reasons, the customer is entitled to request withdrawal from the contract at his discretion.',
        'Liability and similarliabilityin the event of negligent violation of an obligation, the fulfillment of which is essential for the proper execution of the contract and the violation of which jeopardizes the achievement of the purpose of the contract, our liability is limited to the amount of damage that is foreseeable and typical for the type of transaction in question.Lost profits or similarliability for lost profits and wasted expenses or anything similar is excluded.Disclaimerlpt has no further liability or anything comparable.Data backup dutylpt secures the necessary information, data or similar to the extent of the service, web sites, software, products, applications or similar used that are required to use them. Lpt has no obligation to fully secure the information, data or anything similar.Personal liabilitythe above limitation of liability also applications ly to the personal liability of employees, representatives and bodies, partners or similar persons of lpt.Claims for damagesthe customer cannot assert claims for damages against lpt, except in the case of negligence.Confidentialityprinciple of confidentialitythe customer is obliged to treat the information made available to him under this contract as well as knowledge or comparable information acquired during the contractual relationship on matters of a technical, commercial, organizational or comparable nature confidentially and to do so without the obligation for the duration and after termination of the contract not to exploit or use or make available to third parties or similar without the prior written consent of lpt. The customer ensures that employees, subsidiaries, partners or similar are bound to applicationsropriate confidentiality obligations. Use of this information is limited solely to the implementation of this contract. The customer shall inform lpt in writing immediately upon becoming aware of any unauthorized disclosures or possible loss of confidential information or similar.',
        'Legal obligation to disclosurethe prohibition of disclosure does not apply if the customer is obliged to disclose the information by law or by court or official orders. In this case, however, the customer obliged to disclose is obliged to notify lpt in advance of the disclosure of the information so that lpt has the opportunity to defend itself against such disclosure and to prevent or limit it. The customer obliged to disclose will use its best efforts to ensure that all confidential information that is to be disclosed is treated confidentially by the official authorities ordering the disclosure.Continuation of confidentialitythe confidentiality obligations for the customer in this contract remain indefinitely even after termination of this contract. If there are certain legal provisions in this regard, thsese applications ly.Contract takeoverwe are entitled to transfer rights and obligations from this contractual relationship in whole or in part to a third party upon notification. This announcement will be made through one of lpt\'s communication channels (e.G. But not limited to email, account, website, software, applications, etc.).Handover point and availabilityfor the connection to the internet or other connection options, the provision or maintenance of the network connection for the use of our service, websites, software, products, applications or similar as well as the procurement and provision of network access components for the internet or other connection options on the customer side, the customer must do so himself take care. The customer is solely responsible for any such failure, disruption, non-use or similar of our service, websites, software, products, applications or similar.Service level and supportin some cases, it is possible to use our service, websites, software, products, applications or similar outside of operating hours (applications approximately 365 days, 24 hours), but there is no entitlement to this. If, for urgent technical or comparable reasons, maintenance work is exceptionally required during operating hours, with the result that our services, websites, software, products, applications or comparable items are not available during this time, we will, if possible, do this in a timely manner announce customers. This announcement will be made through one of lpt\'s communication channels (e.G. But not limited to email, account, website, software, applications, etc.).The lpt and/or a partner are available to support the customer and can be reached via the lpt\'s communication channels (e.G. But not limited to email, account, website, software, applications, etc.). Lpt has the right to access the',
        'data and information required to support.In most cases, the repairs are carried out by the lpt and/or a partner at no cost. If the customer incurs a charge for troubleshooting, lpt will inform the customer in writing before the fix and any possible costs incurred.With regard to troubleshooting, errors, failures, disruptions and the like are analyzed and corrected by lpt and/or a partner of lpt. No guarantee or guarantee of durability is provided for the successful resolution of these. Errors that are reproducible can be reported by the customer to lpt via customer service. Lpt assumes no guarantee for the loss or similar loss of information or data and cannot be legally prosecuted in this context. The response time in relation to the elimination of errors, failures, disruptions or similar issues is prompt and depends on the situation. A detailed estimate of the reaction time is therefore not given. The customer has no right to have errors, failures, disruptions or similar items rectified. These are analyzed, evaluated and then treated accordingly by the lpt and/or a partner. The lpt and/or a partner are not obliged to disclose details regarding the correction of errors, failures, disruptions or similar. This serves, among other things, security, which could lead to a potential risk through disclosure.Obligation to cooperatethe cooperation required to carry out the contractual services must be provided by the customer in full and in a timely manner. The obligations to cooperate include in particular the following activities by the customer:•all applicable laws and other legal regulations must be observed. It is prohibited to transfer data or content to our servers that violates legal regulations or infringes third-party property rights or copyrights or other third-party rights. If these should still be transferred, then the relevant conditions in these general terms and conditions must be taken into account.•In the event of an error message, all documentation, protocols and other information relevant to troubleshooting must be made available to us immediately.•The customer is obliged to regularly take part in applicationsropriate training courses (if available or offered) or to otherwise acquire the necessary knowledge to use our services, websites, software, products, applications or similar.•Only data that is free of computer viruses or other harmful code may be transmitted to us. The customer bears responsibility in this regard.•No software or other techniques or procedures may be used in connection with the use of our service, websites, software, products, applications or',
        'similar that are likely to impair or cause the operation, security, availability or similar.Blocking of data, information and similarin the event that a third party claims a legal violation or similar against lpt through data, content, information or similar that was transmitted, transferred, handed over or similar to us by the customer, lpt is entitled to use the corresponding data, content, information or comparable to temporarily block if the third party has conclusively demonstrated the violation of the law. In such a case, lpt will ask the customer to stop the infringement within a reasonable period of time or to prove the legality of the content. If the customer does not comply with this request or does so insufficiently (at the discretion of the lpt or the legislature), we are entitled, without prejudice to other rights and claims, to terminate the contract for good cause without observing a notice period. If the customer is responsible for the violation of the law, he is also obliged to compensate for the resulting damage and must indemnify lpt and/or its partners from any third-party claims upon first request. Further rights are reserved.Changes, adjustments or similarthe lpt and/or a partner is entitled at any time to further develop, change, adapt, supplement, delete, sell, terminate or similar parts of our services, websites, software, products, applications or comparable items in whole or in part. These become part of the contract with the customer when they come into force. This does not require any announcement, report or similar to the customer. If an announcement, message or similar is made to the customer, this will be done through one of lpt\'s communication channels (e.G. But not limited to email, account, website, software, applications, etc.).Customized requirements / requestsif a customer requests specific adjustments or something comparable, this can be requested via customer service. Lpt is not obliged to accept or implement customer-specific requirements or anything similar. The requests are analyzed and evaluated accordingly by the lpt. If the lpt decides to implement the request and the customer would incur costs, a written agreement will be made with the customer before implementation. The conditions defined in these general terms and conditions apply to such adjustments, developments and similar items (e.G. But not limited to copyright, terms of use, etc.).',
        'Rights in case of defects and similarother defectsin cases of non-contractual performance, lpt and/or a partner is entitled to supplementary performance and is obliged to do so if required by law. If supplementary performance is not provided within a reasonable period of time, a reasonable grace period with a threat of rejection can be set. If this period has expired unsuccessfully, the customer is entitled to terminate the contract without notice. The customer can claim damages from lpt up to the maximum amount of the contract costs (since the defect was legitimately reported). There is no further claim for damages unless there is a legal claim in this regard. The customer\'s claim regarding such defects expires after 6 months, unless there is a legal regulation for this.Property rights of third partiesconsequences of infridgement of property rightsif the contractual use of our service, websites, software, products, applications or similar causes a violation of the industrial property rights and copyrights of third parties and third parties raise claims against the customer due to such a violation, lpt and/or a partner will be responsible according to our choice at your own expense either•obtain the right to use the service, websites, software, products, applications or similar or•rework, adapt, change or comparable our services, websites, software, products, applications or similar so that there is no longer any infringement of the law and have an acceptable characteristic of the characteristic contractually agreed with the customer.If such an applicationsroach is not effective or is rejected by third parties, lpt will defend the customer within an applicationsropriate framework and at its own discretion. If there is no fault on the part of the customer within the meaning of this agreement or something comparable with lpt or a partner and this can be proven, lpt will not assert any claim for damages against the customer.',
        'Customer’s information obligationthe customer is obliged to notify us immediately if third parties assert infringements of intellectual property rights against him. The customer is only entitled to take measures, in particular to defend himself against the claims in court or to satisfy legal claims of the third party subject to reservation, if we have previously communicated that we will not defend the customer against the claim.Liabilityliability for damages regardless of fault for defects existing at the time the contract was concluded is excluded.Special terms and conditions for online trainingregistrationthe customer has the opportunity to register bindingly online via our service, websites, software, products, applications or similar. In the event that an online training is fully booked or otherwise cannot take place, the customer will be informed of this through one of lpt\'s communication channels (e.G. But not limited to email, account, website, software, applications, etc.). The invoice is issued immediately after the training has been completed and must be paid by the customer within the deadline stated on the invoice.Cancellation for an online trainingthe customer is entitled to cancel an online training free of charge up to 7 calendar days before the start of the online training. Subsequent cancellation by the customer is excluded.',
        'Cancellation or similar of an online training by lptlpt reserves the right to cancel, cancel or similar online training at any time due to insufficient participation or other reasons that we cannot foresee (such as, but not limited to, sudden illness of the speaker, force majeure, etc.). Lpt is not obliged to give a reason for this. The customer will be informed of this by lpt through one of lpt\'s communication channels (e.G. But not limited to email, account, website, software, applications, etc.). In this case, the online training will not be charged. The customer has no right to an alternative date or anything comparable. If a training course is booked within the contract period but only takes place after the end of the terminated contract period, it can no longer be attended.Subject to changelpt is entitled to make necessary content, methodological, organizational or comparable changes, adjustments, deviations and similar things before, during or after the online training. Furthermore, we are entitled to change speakers or similar speakers at any time without giving or communicating a reason. The documents, information or comparable items provided as part of the further training are created to the best of our knowledge and level of knowledge. Liability and guarantee for the correctness, topicality, completeness, quality or comparable of the data, content, information or comparable are excluded.',
        'Retention of title and uselpt reserves unrestricted ownership of all deliveries of teaching materials, data, information and similar items until all payment obligations have been fully fulfilled by the customer. Customers receive the non-exclusive right to use the teaching materials, data, information and similar items, unrestricted in terms of time and space. Passing on to third parties, i.E. To people, work colleagues, employees of the customer, partners or similar, or the public distribution or making accessible of teaching materials, data, information or similar is not permitted. In particular, the publication of audio or video data, digital presentations or scripts as well as the like in publicly accessible internet portals (sharing) or similar is prohibited. The same applies to the editing, modification, adaptation or comparable of the teaching materials, data, information or comparable of the online training. The teaching materials, data, information and comparable items, in particular records and documents and comparable items, are available to the customer until the end of the contract term. The customer is not entitled to store teaching materials, data, information or similar items locally without the prior written consent of lpt. If the customer has legally saved teaching materials, data, information and similar items at the end of the contract, this right expires at the end of the contract and must be completely deleted by the customer without a separate request from lpt. After the customer has carried out the complete deletion, the customer must inform lpt in writing of the complete deletion. Incomplete deletion by the customer is not permitted, even after a written request from the customer.',
        'Customer servicecustomer service represents the basic point of contact between any person, regardless whether or not customer, and the company, therefore all your queries should be addressed to customer service.Please bear in mind that customer service gives to your queries all due importance and consideration. We try our best to answer your queries as quick as possible. If you have any query, please have a look at our agreements, terms and conditions.Customer service email address: Customer Servicemodifications to our agreements, terms and conditionswe reserve the right to change our agreements, terms and conditions at any time by posting revisions on our web site and/or platsforms and/or softwares and/or mobile applications or others of us. Such changes will be effective upon posting or uploading.Invalid or unenforceableif any of the provisions of this agreement becomes or is held invalid or unenforceable:all other provisions hereof shall remain in full force and effect; andthe invalid provision or unenforceable provision shall be deemed to be automatically amended and replaced by a valid or enforceable provision which economically accomplishes as far as possible the purpose and the intent of the invalid and unenforceable provision.The same rules apply to unintended omissions (if any).',
        'Privacy policy (cookies and data protection)we welcome you to our web site, facilities, platforms, softwares, applications and others. Lpt (hereinafter called ‚lpt‘, ‚幸运丹鸟（珠海）科技有限公司‘) and its affiliates (together, ‚we‘, ‚our‘ or ‚us‘) respects the privacy of our users and its strongly committed to protecting the users privacy. This privacy policy applies to this web site, to any, softwares or applications of us, any web site of us or us at third-party web sites, softwares, services and applications, and information collected (online or offline) and provided to us, but does not apply to any other product or service of us, unless otherwise explicit expressly indicated by us (such as by including a link to this privacy policy on other web sites of us or on, softwares or mobile applications of us).Storage of your ip addresswe store the ip address transmitted by your web browser strictly for the purpose of identifying, restricting and eliminating attacks on our website, softwares or mobile applications or for our services, facilities and others of us or any third-party we may have accepted. We store your ip address for as long as it is necessary for the provision of our service or others of us and the deletion does not conflict with any retention periods.',
        'Collection of your personal informationwe, or where relevant a designated service provider, collects personal information and data that you voluntarily provide on our website, softwares, mobile applications, on third-party websites, softwares and applications (online or offline), which may include your name, address, email address, contact information, credit card number, billing information, password, age etc. As an example, we or a designated service provider collects such information if you register on our website, softwares, mobile applications etc. We collect personal information you provide to us when you use our web sites, softwares, mobile applications, services, products or register for an account with us, this may include first and last name, date of birth, credit card information, username and password, proof of age and identity, billing address, home address, email address, phone number or other contact information. Furthermore, we collect technical information about your device and the platform such as administrative and traffic information including but not limited to: source ip address, time of access, date of access, type of devise, web page(s) visited, language use, your location, roaming trace, software crash reports and type of browser used. This information is essential for the provision and quality of the services and others. We collect your public profile, including, name, photo and other information you make available to us when you like, post or otherwise interact with our social media pages or other services and products. We may keep records of communications when you contact us or otherwise interact with us, including via email, letter, text message (sms), online, softwares, messaging applicationss such as whatsapplications and skype, telephone or live chat function on our website and others. We also collect other information from third-parties databases to comply with our legal and regulatory obligations. We may also receive your personal information from online vendors and service providers such as financial and shared liquidity services, and from customer lists lawfully acquired from third-party vendors. We may collect additional information about you where you provide such information to us through your use of our services, web sites, softwares, mobile applications or products. If you do not provide certain personal information, not all functionality on our websites, softwares or mobile applications will be available.',
        'Information about others provided by youplease do not provide any information about others unless you are authorized to do so and consent to have all information used, disclosed and transferred in accordance with this privacy policy. In case you submitting such information about others, you represent and warrant that you are auhtorized to do so, this includes you have received authorization from the person you provide information about, about whom you are providing those information and the person has consented to have all information used, disclosed and transferred in accordance with this privacy policy.Please be aware of the rules surrounding the uploading of third-party content to our web sites, softwares, mobile applications, services, products or other. Please note that this privacy policy will be agreed between you and us and will form part of your agreements with us. We may periodically make changes to this privacy policy and strongly recommend that you revisit this privacy policy regularly.Please note following terms and conditions:we do not claim any ownership rights in any third-party content posted by you on our web sites, softwares, mobile applications, services, products or other. You agree that you are solely responsible for any third-party content posted by you under your user id.You hereby grant to us a non-exclusive, royalty-free, worldwide, perpetual licence (including the right to sub-license) to use (and to make such copies thereof as we deem necessary in order to facilitate the posting and storage of your third-party content on our web sites, softwares, mobile applications, services, products and others or in connection with any promotions in all media now known or hereinafter developed.You warrant to us that you have full power and authority to grant the licence at 2) above and that the third-party content posted by youdoes not infringe any third-party\'s intellectual property rights, other proprietary rights or rights of publicity or privacy;does not violate any law, statute, ordinance or regulation;is not defamatory, trade libellous, unlawfully threatening or unlawfully harassing;is not obscene or pornographic and does not contain child pornography;does not violate any laws regarding unfair competition, anti-discrimination or false advertising;does not constitute any of the types of prohibited third-party',
        'content anddoes not contain any viruses, trojan horses, worms, time bombs, cancel bots or other computer programming routines that are intended to damage, detrimentally interfere with, surreptitiously intercept or expropriate any system, data or personal information.You agree to pay for all royalties, fees or any other monies owed to any third-party as a result of you posting any third-party content on any of our web sites, softwares, mobile applications, services, products or other.You acknowledge that the following constitutes (but is not limited to) prohibited third-party content: third-party content which:is offensive, promotes racism, bigotry, hatred or physical harm of any kind against any lpt or individual or exploits, harasses or advocates harassment of any person; constitutes information that you know is false or misleading or promotes illegal activities or conduct that is abusive, threatening, obscene, defamatory or libelous; contains nudity, excessive violence, or offensive subject matter or links to any such content; solicits personal information from anyone under eighteen years of age or under such other higher or lower minimum legal age in your jurisdiction; contains information that poses or creates a privacy or security risk to any person; contains an unauthorised copy of another person\'s copyrighted work; and includes a photograph or video of another person that you have posted without that person\'s consent. Use of your personal information an d information usewe use the information for considered business purposes, which also benefits customers and which includes some or all of the following and may more, to:provide our service and productshelp and support improving our services and productsdevelop new services and productscommunicate with you and customersprovide internal quality control purposesprovide you with informationprovide you with offers and promotions about services and',
        'products of us or other parties that may be of interest to you or customersenhance your experience with the websites, softwares or mobile applications, including to save your preferences, login information etc.Analyze the websites, softwares or mobile applications usage and the use of the websites, softwares or mobile applicationsoperate our services, products, systems etc.Protect the interests, rights, properties or safety of us or others and to monitor complicance with and enforce the terms of any agreement with us.Provide customer support and service messages, including messages requesting your feedback on our services and may notifying you about changes to our website, services or changes to our terms, conditions and policies. To conduct security reviews at any time to validate your identity, age, the registration information provided by you and to verify your use of our services and your financial transactions for potential breach of our general agreements, terms and conditions and of applicable law. Security reviews may include for example, ordering a credit report and/or otherwise verifying the information you provide against third-party databases. To process any of your online transactions and payments (including disclosing your personal information to third-party payment processors, and other financial institutions as necessary).To assist your participation in third-party promotions, market research and events. Customer telephone and chat conversations may be recorded to allow us to improve the quality of our customer service and our products, train staff and to record what is said in the event of a subsequent complaint. Provide you with promotional offers and information where you have indicated or we have inferred an interest in our products. We monitor use of our web sites, softwares, mobile applications, online services and products, and use your',
        'personal information to help us improve and protect our content, services and web sites, both online and offline. We use personal information to personalise our web site, softwares, mobile applications, services and products for you. We monitor customer accounts to prevent the use of unfair practices in our web site, softwares, mobile applications, services and products. We use personal information to investigate any complaints received from you or from others, about our web sites, softwares, mobile applications, services or products. We may be required to share your data with trusted third-parties who provide us with services relevant to our provision our facilities, including customer support, information security, payments, marketing, data analysis, research and surveys. We will use personal information in connection with legal claims, and for compliance, regulatory and investigative purposes as necessary (including disclosure of such information in connection with legal process or litigation). We use your personal information in order to build up a profile of your demographics, likely behaviours and preferences. This is used to inform the decisions we make in relation to the services, content and promotions we offer. We also report on the different contribution to our commercial performance from different customer profiles. We create profiles through manual or automated processes, including from third-party providers.Subject to your marketing preferences (if applicable) , we will use your personal information to deliver marketing communications which may be of interest across various platforms, such as email, text message, telephone, mail post, online, inbox messaging, push notifications or other available channels to provide you with information regarding our products, services and promotions, including other. To share your contact details with selected media partners and affiliates for the purposes of them being able to offer their own marketing services to you. We only do this where we have your consent and in line with your marketing preferences.',
        'To enter you into surveys or promotions you have agreed to.We place cookies and use similar technologies in accordance with our policy/policieson other occasions where we ask you for your permission, we will use your personal information for the purpose which we explain at that time. In response to requests by government or law enforcement authorities conducting an investigation. Investigate and/or report fraud, terrorism, misrepresentation, security incidents or crime, in accordance with applicable law.We us any credit card or payment information we acquire from you to fulfill services, products or others. You can update your settings. Please note that changes of your settings in a specific manner, you will continue to receive some information concerning your account, services and products your requested, and in response to any requests for information by you. Please be aware some specific changes of your settings may have an impact on functionalities, and you may have not all functionalities. Please note that in case of use of the opt-out function, it may take some time to complete, consistent with applicable law.We may take videos or photographs for security or other business purposes and for inclusion the people directory.Data backup dutywe secure all data, information and comparable items effectively against unauthorized access, modification, destruction or loss, unauthorized transmission, other unauthorized processing and other misuse, as far as this is possible with technically and economically justifiable effort. If a threat to data, information or comparable items cannot be remedied in another way with technically and economically applicationsropriate effort or is not promising, lpt is entitled to delete data, information or similar items containing damaging content.',
        'Consequences of termination of the contractif the contractual relationship is terminated, regardless of the legal reason, the parties are obliged to carry out the contractual relationship properly. In this context, lpt is entitled to immediately delete all of the customer\'s data, information or comparable items. The customer\'s access, accounts and similar items are automatically blocked, blocked, deleted or similar upon termination of the contract. Lpt is not obliged to hand over data, information or anything similar to the customer.Use of cookies and other electronic toolswe and the parties with whom we are working (like service providers, advertisers, advertising servers, business partner etc.) May place, use, view etc. ‚Cookies‘, web beacons, webserver logs or other electronic tools to collect statistical and other information about you and your usage of the websites, other web sites, softwares or mobile applications. This information may include information about your ip address, ip address of your computer, browser type, operating system, your mobile device, settings, browser type, device id, geo-location data, the state, city, village or country from which you access or registrate this web sites, softwares or mobile applications, the web pages you visited, the data, time of visit, the websites you visited immediately before and after visiting this website, number of links you click wihtin these web sites, softwares or mobil applications, functions you use on these web sites, softwares or mobile applications database you view, searches you request on these web sites, softwares or mobile applications, data and information you save on or download from these web sites, softwares or mobile applications and the number of times you view advertisement (on web sites, softwares or mobile applications etc.) Etc.We and the parties with whom we may use the information and data collected for various reasons, either on behalf of us or for the other parties own purposes, including for example improvement, research, analysis etc. To better serve users, visitors or customers of these web sites, softwares or mobile applications (such as by register, enabling log-in, providing access to pages, services, products of the web sites, softwares or mobile applications, providing customized or other content, presenting online or offline advertising on the web sites, softwares or mobile applications), to compile aggregate and anonymous information and data about usage etc. Of these web sites, softwares or mobile applications, other statistics etc. If you decide and have deleted and disabled cookies, uses as',
        'described will not be possible to the extent they are based on cookie information.If you like to assist us with the uses etc. Described in this privacy policy, regarding information and data collected, analyzed etc. About you and your use of these web sites, softwares or mobile applications may be aggregated, analyzed or combined with personal or any other information and data about you and your uses from other online or offline sources. In case you do not prefer that we combine non-personal information and data that has been collected etc. Through cookies about you and your uses etc. Of these web sites, softwares or mobile applications with personal or other information or data about you and your uses etc., Then please delete and disable cookies for each browser, on each computer, mobile device, laptop or any other device you use to surf the web.Please be aware that most browsers are set to accept cookies by default. In case you prefer, you can usually set your browser to alert you when cookies are being sent or to disable cookies. According mobile devices, most of them allow you to disable the ability for geo-location information and data to be collected from your mobile device. Most of the browsers, mobile device or others have a help or support function, which contains instructions on how to set your browser, mobile device or other to notify you before accepting, disable cookies or disable the collection of geo.Location data and information. You have to set your preferences on each device you use to surf on the web. However, if you disable cookies or refuse to accept a request to place cookies or a cookie, it is possible that same functions or parts of the web site, softwares, mobile applications or others like for example such as the polls, contents, surveys, product sales, may updates or others and certain areas of the web site, mobile device or others for which you need to log in, will not function properly and the advertising or others you may receive when you visit the web sites, mobile device or others may not be tailored to your interest or working at all.',
        'Advertisementswe, our designated service providers or third-party advertisers or any advertising servers may place or recognize cookies on your or our computer, laptop, mobile device, softwares, mobile applications or other electronic tool or other. However, those are supporting or helping to display advertisements you can see on our web sites, mobile devices, softwares, mobile applications or any other. Data and information about your visits to or from, and activities on, our web sites, mobile devices, softwares, mobile applications or others, an ip address, the number of times you have viewed an advertisment, and other such data and information is used, alone or in any kind of combination with other data and information, to display advertisment on your display, screen, mobile device or any others of yours that may be of particuar interest to you. We or other third-parties may use web beacons, provided by third-party adverting companies or any other kind of companies, to help manage and optimize our online and may offline advertising and product performance or kind of such. Web beacons enable us to recognize a browser’s cookie when a browser visits web sites of us, or mobile devices, softwares, mobile applications or others and to give us the opportunity to learn which banner ads or others bring users to our web sites, mobile devices, softwares, mobile applications or others. This privacy policy does not cover the use and collection of your data and information by these third-party service providers, and third-party advertisers and their advertising servers. If you not accept any of those, please don’t visit and/or use our websites, mobile devices, mobile applications, softwares, facilities, applicationss or others.Not that even, if you excercise choice for targeted advertising, you will still may receive online or offline advertising.',
        'Disclosure of your personal information and datawe may share your personal information and data with other affiliates (including affiliated web sites under common ownership or control), subsidiaries and designated service providers, including for the purposes set out in our privacy policy or any other of us. We may share with other third-parties data and information about our web site users, mobile device users, softwares, mobile applications users or other product users of us, such as your use of our web sites or other web sites, softwares, mobile applications and services provided on the web sites, mobile devices, softwares, mobile applications or others of us. We may share data and information (including personal information) with a sponsor, third-party provider or other third-party, which provides you with promotions, offers or other information and data that may be of interest for you. If you instruct us not to share your personal information covered by our privacy policy with third-party providers like such, please use the opt-out function. Please note, if you decide to use this opt-out function, please be aware that some functions of the web sites, softwares, mobile applications or others of us may not work. Please note furthermore, that this opt-out process may take some time to complete. Even after such opt-out process is completed, your personal data and personal information may continue to be shared with our affiliates, subsidiaries (including affiliate web sites, softwares under common ownership or control or mobile applications under common ownership or control or similiar others) and designated service providers.If you decide to participate in certain features of our web sites, mobile aplications or others, please note that any data and information (excluding security data and information like password) you or others voluntarily disclose through use of these features, becomes available to us and to the public and/or other users whom you have designated or not. If you choose to provide access to designated users or individuals, please note such information you post will be visible to such users or individuals for their use and may for us as well. We are not responsible for any data or information that you or others choose to disclose publicly or provide access to designated individuals on our web sites, softwares, mobile applications or others of us, and neither we nor others use of such data and information is subject to this privacy policy.We may disclose your personal data and information to unaffiliated third-parties, if we believe in good faith that such disclosure is required or necessary to:protect the interests, rights, safety or property of us or',
        'others;comply with any applicable law, regulation, rule or in respone to a court order or other legal process, subject to us;share with law enforcement and public authorities in order to comply with any legal obligation or where we believe we are under a duty to comply with an obligation.Share with third-parties in order to enforce our terms of use and any other agreement; or to protect the rights, property, safety, or security of us, third-parties or the public;share with other online sites, banks, credit card companies, and applicationsropriate agencies, where you are found to have cheated or attempted to defraud us or any other user of our services, which may include but not limited to manipulation, payment fraud, or prohibited transaction; share with third-parties in the event of sale, purchase of assets, merger, bankruptcy or reorganization proceeding;share to third-party service providers, who will process it on our behalf for the purposes identified above. Such third-parties include providers of website hosting, maintenance, call centre operation, identity checking, information verification services, marketing, data analysis, research and surveys, third-party electronic payment processors and/or financial institutions to process financial transactions and other organisations that provide technical support, process your online transactions and maintain your account;monitor compliance with and enforce any terms and or conditions of service on our web sites, softwares, mobile applications or others;provide our services, products, softwares, applications and others (including allowing a purchaser of us or divisison or subsidiaries or others to continue to serve you)provide and perform other activities related to such services, products, softwares, applications and others (including for example billing and collection)provide you with promotions or offers from us or other third-partiesoperate the systems that provide and run our sevices, products, softwares, applications and others properly.',
        'The collection, further use and/or disclosure of your personal data and information and information by third-party providers or other third-parties is not the responsibility of us. Rather, such collection, use and/or disclosure is governed by the third-parties privacy policy.Accuracy, security and retention of your personal informationwe understand the importance of information security and the techniques needed to secure information. Any data and information you provide to us is kept on secure places. We may use third-party storages, clouds, servers or others. We may use reasonable organisational, technical and administrative measures to protect your personal data from unauthorised access to or unauthorised alteration, disclosure or destruction of information that we for example hold. To help us protect your privacy, you should maintain the secrecy of the logon id and password you may have set up in connection with your participation in our web sites, services, products, softwares, mobile applications or others of us. The period for which we may retain data about you will depend on the purposes for which the data was collected, whether you have requested the deletion of the data, and whether any legal obligations require the retention of the data (for example, for regulatory compliance). Personal information is retained for as long as is necessary for the purpose for which it is collected, including legitimate business reasons and/or requirements.Protection and secure your account informationthose are some opportunities to consider on how to keep login information secure:never share a computer accountnever use the same password for more than one accountnever tell anyone your password, even people who claim to be from customer service or securitynever write down your passwordnever communicate a password by telephone, email or instant messagingbe careful to log off before leaving a computer unattendedchange passwords whenever there is suspicion, they may have been compromisedkeep operating system passwords, softwares and applications passwords differentpassword should be alpha-numericmake passwords random but easy for you to remembermaintain up-to-date anti-virus software',
        'maintain an up-to-date personal firewallavoid the usage of your account on computers which are accessible to the public eg. Internet cafeschange your password regularlykeep your os, browser, and browser plugins up-to-datedisable or uninstall any software or browser plug-ins you don’t use — this reduces your vulnerability.Please choose your password choice wisely by for example adding upper- and lower-case letters, one or more numerical digits etc.You may receive a notification, if for example your password should be expired or changed.Rights with respect to your personal informationdepending on the jurisdiction:you may have the right to access, correct, delete or restrict use of certain personal data and information covered by our privacy policy;you may have the right to request that we refrain from processing personal information.Please be aware, that if you exercise such rights this may affect our ability to provide our products, services, functions may not work on the web site, softwares, mobile applications or others. For inquiries regarding your personal information please get in contact with us. Where we process your personal information for compliance with our legal obligations, we will do so in accordance with all retention periods specified by applicable law. While we will make reasonable efforts to accomodate on such requests, we reserve the right to impose certain restrictions and requirements on such requests, if allowed or required. Please note such requests may take some time.',
        'Globally transfers (treansfer of your personal information to ther countries)as with any multinational organisation, we are often required to transfer data internationally. Accordingly, data about you may be transferred globally (if your data is collected within the european economic area, this means that your data may be transferred outside of it). We may transfer and processing your personal data and information mentioned in our privacy policy to and in various countries that may have different levels of privacy protection than your country. Furthermore, some of the uses and/or disclosure mentioned in our privacy policy may involve the transfer and processing of your personal data and information to and in various countries that may have different levels of privacy protection than your country. By entering our web sites, mobile devices or others and/or using of our services, products, softwares, mobile applications or others you consent to such transfer and processing, including to and in the united states or any other country. Furthermore, by entering our web sites, mobile devices or others and/or using of our services, products, softwares, mobile applications or others, you consent that the privacy protection of your personal data and information will be as in the country those personal data and information have been transferred to and are processing.E-commerceaccording to the e-commerce directives implemented, the company provides the following information pertaining to the conclusion of contracts (registration, paying in and out as well as each individual service) on the internet. With your registration with the company, you declare to have attained the minimum age required in accordance to the respective national legal system. In addition, you agree to and accept the general agreements, terms and conditions, which deal with registration, paying in and out as well as other services in its entirety. Your contract formulas (registration, paying in and out, as well as each individual service) are all saved by the company or designated third parties. For safety reasons only, certain extracts of this data can be viewed and altered in your personal account. If you would like to change some of your personal details, which you provided when registering, you may do so in your account under settings. In your account you may also change your password by clicking on change password.',
        'Links to third-party web sites, softwares, mobile applications and othersplease note that we may provide links to third-party web sites, softwares, mobile applications, or others incuding social networking web sites. Since we do not control third-party sites, web sites, softwares, mobile applications or others and are not responsible for any data or any information you may provide while on such sites, web sites, softwares, mobile applications or others, we encourage you to read the privacy policies on those web sites, sites, softwares, mobile applications or others before you providing any of your data and information on such sites, web sites, platforms, softwares, mobile applications or others.Image rightswe may acquire photographs, videos or others from various sources.Contact according our privacy policy and mentioned opt_out functions or othersplease contact following address (‚under ‚who to contact‘) in case of opt-out as mentioned in our privacy policy. Please note such requests may take some time.Who to contactlpt is registered in china under company number 91440400macd90me4a.If you have any questions, or wish to exercise any of your rights, please contact us at Customer Service.Modification to our privacy policywe reserve the right to change our privacy policy at any time by posting revisions on our web site and/or platsforms and/or softwares and/or mobile applications or others of us. Such changes will be effective upon posting or uploading. We recommend that you revisit this privacy policy regularly.Invalid or unenforceableif any of the provisions of this agreement becomes or is held invalid or unenforceable:all other provisions hereof shall remain in full force and effect; andthe invalid provision or unenforceable provision shall be deemed to be automatically amended and replaced by a valid or enforceable provision which economically accomplishes as far as possible the purpose and the intent of the invalid and unenforceable provision.',
        'The same rules apply to unintended omissions (if any).Users policywe welcome you to our web site, facilities, platforms, softwares, applications and others. Lpt (hereinafter called ‚lpt‘, ‚幸运丹鸟（珠海）科技有限公司‘) and its affiliates (together, ‚we‘, ‚our‘, or ‚us‘). This user policy applies to this web site, to any software or applications of us, any web site of us or us at third-party web sites, softwares and applications (online or offline), but does not apply to any other product or service of us, unless otherwise explicit expressly indicated by us (such as by including a link to this user policy on other web sites, softwares of us or on mobile applications of us).Use of the web site, softwares, mobile applications and other services or products of ususe of our web sites, softwares, mobile applications or other services and products of us are only permitted for personal, non-commercial and commercial purposes. All other use is strictly prohibited, if you enter, access, log in, register our web sites, softwares, mobile applications or other services and products of us, you agree:not to collect, copy, extract and/or reproduce on any other web site, softwares, mobile applications (online or offline) any information, data or material of our web sites, softwares, mobile applications, services or products of us, whether by use of any kind of method;not to use our web sites, softwares, mobil applications, services or products to provide information or data relating to us, our affiliates or our subsidiaries to any third-party, other than for your own personal, non-commercial and commercial purposes as defined in the agreements and contracts with lpt;not to use our names, brands or contents of our web sites, softwares, mobile applications, service or products any other than for your own personal, non-commercial and commercial purposes;not to use our failities, services, products, platforms, web',
        'sites, softwares, applications or other for money laundering;to be legally bound by the terms and conditions of our user policy, requirements, terms and conditions or other policies of us.Modification to our user policywe reserve the right to change our user policy at any time by posting revisions on our web site and/or platsforms and/or softwares and/or mobile applications or others of us. Such changes will be effective upon posting or uploading.Invalid or unenforceableif any of the provisions of this agreement becomes or is held invalid or unenforceable:all other provisions hereof shall remain in full force and effect; andthe invalid provision or unenforceable provision shall be deemed to be automatically amended and replaced by a valid or enforceable provision which economically accomplishes as far as possible the purpose and the intent of the invalid and unenforceable provision.The same rules apply to unintended omissions (if any).Usage of social media plug-ins and otherson our platforms, facilities, web sites, softwares, applications and others of us, you may find links and/or data matrix codes and/or any other connection (‚link‘) to the social media services of including but not limited to may youtube, myvideo, facebook, linkedin, xing, twitter, wechat and others. Following these links will take you to their platforms, facilities, services and others and/or give you the opportunity to share including but not limited to a page, video, picture and others, which may require an account at the social media service. By clicking on the link to a social media service, a connection to the server or others of the social media service is may established. This may transfer the information and/or data that you have visit our web site, platform, service, facility, software, applications or others to the server or others of the social media service. May further information is transferred to the provider of the social media service. These are inclduing but not limited to:address of the web site on which the activated link is locateddate and time of accessing the web site or activating the link',
        'information about the browser and operating system usedip address etc.If you are already logged in to the relevant social media service at the time the link is activated, the provider of the social media service may be able to determine your user name and, if applicable, may your real name from the transmitted data and correlate this information to your personal user account at the social media service. You may can exclude this by logging out of your user account beforehand.The servers of the social media services are may located in europe and/or may located in the usa and/or other countries outside the european union. The data can therefore also be processed by the provider of the social media service in countries outdside the european union. Please note that companies in these countries are subjects to a data protection lay that does not generally protect personal data to the same extent as in the member states of the european union. For further information please refer to the privacy policy of the respective social media service. To the extent permitted by law, we will not be liable for any such action.Modifications to our social media plug-ins and otherswe reserve the right to change our social media plug-ins and others at any time by posting revisions on our web site and/or platsforms and/or softwares and/or mobile applications or others of us. Such changes will be effective upon posting or uploading.Invalid or unenforceableif any of the provisions of this agreement becomes or is held invalid or unenforceable:all other provisions hereof shall remain in full force and effect; andthe invalid provision or unenforceable provision shall be deemed to be automatically amended and replaced by a valid or enforceable provision which economically accomplishes as far as possible the purpose and the intent of the invalid and unenforceable provision.The same rules apply to unintended omissions (if any).',
      ],
      privacyContent: 'This is the privacy policy for the LPT audit platform...',
      close: 'Close'
    },
    payment: {
      innerSteps: {
        0: 'Select method',
        1: 'Pay',
        2: 'Confirmation'
      },
      modes: {
        oneTime: {
          title: 'One-time payment',
          badge: 'Pay once',
          desc: 'Complete the purchase in a single charge.'
        },
        subscription: {
          title: 'Subscription',
          badge: 'Auto-renew',
          desc: 'Recurring billing with automatic renewal.'
        }
      },
      selectMethod: 'Choose your payment method',
      oneTime: {
        desc: 'Choose a method for a one-time charge.'
      },
      amountToPay: 'Amount to pay',
      recommended: 'Recommended',
      proceedToPay: 'Proceed to payment',
      methodMeta: {
        processor: 'Processor',
        flow: 'Flow'
      },
      alipayProceed: 'Go to Alipay',
      alipayRedirectTip: 'You will be redirected to a secure payment page (Alipay).',
      alipayMode: {
        title: 'Choose an Alipay flow',
        subtitle: 'Continue to login checkout or scan a QR code.',
        redirect: {
          title: 'Login checkout',
          desc: 'Open the official Alipay checkout and complete payment after login.',
          tip: 'You will be redirected to the official Alipay checkout page to finish payment.',
          action: 'Continue to Alipay'
        },
        qr: {
          title: 'QR code payment',
          desc: 'Scan with the Alipay app to complete payment.',
          tip: 'Open the Alipay app and scan the QR code to pay.',
          generating: 'Generating Alipay QR code, please wait...',
          orderNo: 'Order No.',
          checkStatus: 'I have paid',
          pending: 'Payment success has not been detected yet. Please try again later.'
        }
      },
      scanQrCode: 'Open Alipay and scan the QR code to pay',
      qrExpires: 'QR code expires in {seconds} seconds',
      qrExpired: 'QR code expired. Please try again.',
      simulatePay: 'Simulate payment success',
      verifying: 'Verifying payment...',
      changeMethod: 'Change method',
      processing: 'Processing payment...',
      payNow: 'Pay Now {amount}',
      initError: 'Unable to initialize payment. Please try again.',
      formLoadError: 'Payment form failed to load. Please try again.',
      cardFailed: 'Payment failed. Please check your card details.',
      fillAllFields: 'Please fill in all card details',
      securityNote: 'Your payment information is encrypted. We do not store your card details.',
      subscription: {
        title: 'Subscription checkout',
        desc: 'Your plan will renew automatically on the selected interval.',
        amountLabel: 'Recurring amount',
        start: 'Start subscription',
        checkoutMethod: 'Stripe Checkout',
        cardTitle: 'Subscription details',
        interval: 'Billing cycle',
        monthly: 'Monthly',
        yearly: 'Yearly',
        renewal: 'Renewal',
        autoRenew: 'Auto-renew enabled',
        paymentMethod: 'Payment method',
        cardOnly: 'Card via Stripe Checkout',
        checkoutError: 'Unable to start the subscription. Please try again.'
      },
      wechat: {
        scanQrCode: 'Open WeChat and scan the QR code to pay',
        generating: 'Generating QR code, please wait...'
      },
      methods: {
        card: {
          name: 'Card payment',
          shortName: 'CARD',
          desc: 'Pay securely with Visa, Mastercard, or another supported card.',
          badge: 'Visa / Mastercard',
          processor: 'Secure gateway',
          flow: 'Embedded secure form'
        },
        stripe: {
          name: 'Stripe'
        },
        alipay: {
          name: 'Alipay direct',
          desc: 'Use the direct Alipay channel and continue on the official Alipay checkout page.',
          badge: 'Direct channel',
          processor: 'Alipay',
          flow: 'Redirect to Alipay'
        },
        visa: {
          name: 'Visa',
          desc: 'Pay with Visa credit or debit card'
        },
        mastercard: {
          name: 'Mastercard',
          desc: 'Pay with Mastercard credit or debit card'
        },
        wechat: {
          name: 'WeChat Pay',
          desc: 'Pay with WeChat Pay by scanning a QR code'
        }
      },
      cardForm: {
        kicker: 'Secure checkout',
        title: 'Card payment',
        acceptedCards: 'Accepted cards',
        moreCards: 'Cards',
        cardDetails: 'Card details',
        helper: 'Enter your card information in the secure encrypted form.',
        number: 'Card number',
        numberPlaceholder: '0000 0000 0000 0000',
        holderName: 'Cardholder name',
        holderNamePlaceholder: 'Name on card',
        expiry: 'Expiry date',
        expiryPlaceholder: 'MM/YY',
        cvv: 'Security code',
        cvvPlaceholder: '•••'
      },
      result: {
        oneTimeSuccessTitle: 'Payment successful!',
        oneTimeSuccessDesc: 'Your one-time payment is complete. Welcome to the LPT platform!',
        subscriptionSuccessTitle: 'Subscription active!',
        subscriptionSuccessDesc: 'Your subscription is active and will renew automatically.',
        failedTitle: 'Payment failed',
        failedDesc: 'There was an issue processing your payment. Please try again or use a different method.',
        orderId: 'Order ID',
        amount: 'Amount paid',
        method: 'Payment method',
        time: 'Payment time',
        downloadShortcut: 'Download LPT Audit Platform',
        shortcutFileName: 'LPT Audit Platform',
        viewInvoice: 'View invoice',
        shortcutDownloaded: 'LPT Audit Platform shortcut downloaded',
        goToDashboard: 'Go to dashboard',
        retry: 'Try again'
      }
    },
    invoice: {
      paymentQr: {
        title: 'Payment QR code information',
        alt: 'MT invoice payment QR code'
      },
      exportPdf: 'Export PDF',
      exportingPdf: 'Exporting...',
      exportXml: 'Export XML',
      exportingXml: 'Exporting XML...',
      uploadedTitle: 'Uploaded invoice',
      openUploadedInvoice: 'Open invoice',
      downloadUploadedImage: 'Download invoice image',
      downloadUploadedImageFailed: 'Failed to download the invoice image.',
      languagesLine: 'Languages: {languages}',
      tax: 'Tax',
      taxWithRate: 'Tax ({rate})',
      seeInvoice: 'see invoice',
      labels: {
        documentTitle: 'INVOICE/DEBIT Note', issueDate: 'Issue Date', clientNo: 'Client No.', organization: 'Organization', address: 'Address', name: 'Name', email: 'Email', phone: 'Phone', taxId: 'Tax ID', registrationNo: 'Registration No1.', matter: 'Matter', period: 'Period', currency: 'Currency', amount: 'Amount', subtotal: 'Subtotal', discount: 'Discount', billingAmount: 'Billing amount', customerService: 'Customer Service', customerServiceText: 'Please contact us at any time through your account under customer service.', paymentInstructions: 'Payment Instructions', paymentText: 'Your bank account will be debited with the billing amount within the next few days. Please note that our charge are net of any wire transfer or other banking charges. Our Terms and Conditions apply.',
        paymentNote: 'The invoice can be found in your payment history of our software for a certain time.',
        bankInformation: 'Our Bank Information'
      },
      xmlExportSuccess: 'XML invoice exported.',
      xmlExportFailed: 'Failed to export XML invoice.',
      xmlExportMissingFields: 'Cannot export XML. Missing required fields: {fields}.',
      xmlFields: {
        invoiceNumber: 'invoice number',
        issueDate: 'issue date',
        currency: 'currency',
        supplierName: 'supplier name',
        customerOrganization: 'customer organization',
        customerAddress: 'customer address',
        invoiceItems: 'invoice items',
        totalAmount: 'total amount'
      }
    },
    errors: {
      loadPurchaseConfig: 'Unable to load purchase configuration. Please try again later.',
      createOrder: 'Order creation failed. Please check your login status.'
    }
  },
  login: {
    backButtonTitle: 'Go Back',
    title: 'Sign In',
    subtitle: 'Enter your credentials to access your account',
    emailLabel: 'Email Address',
    emailPlaceholder: 'Enter your email',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter your password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password?',
    loginButton: 'Login Now',
    registerPrompt: 'Don\'t have an account?',
    registerLink: 'Create Account',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    incorrectCredentials: 'Incorrect email or password',
    userNotFound: 'User not found',
    formInvalid: 'Please fill in correctly',
    validation: {
      emailRequired: 'Please input email address',
      emailInvalid: 'Please input correct email address',
      passwordRequired: 'Please input password'
    },
    viewTerms: 'Terms and Conditions',
    viewPrivacy: 'Privacy Policy',
    agreePrefix: 'I have read and agree to the',
    agreeAnd: 'and',
    termsOfService: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    close: 'Close',
    termsClose: 'Close',
    privacyContent: 'Privacy policy content.',
    termsContent: [
      '幸运丹鸟（珠海）科技有限公司Agreements, Terms and Conditions',
      'These Agreements, Terms and Conditions, including without limitation the Data Processing and Security Agreement or terms, and each Addendum to the Agreement, the Service Level Agreement, and the LPT Audit Acceptable Use Policy, in each case as amended from time to time, constitute a legal contract between you, the Licensee, and Lucky DanNiao (Zhuhai) Technology Co., Ltd., a People\'s Republic of China company ("LPT", "we", "us"), for your use of the Licensed Materials. In order to access the Licensed Materials, you must first review and agree to the terms. You are prohibited from using the Licensed Materials in violation of the terms of the Agreement and/or the Policies. Any individual, person, or entity designated as a Licensee, Client, Auditor, or Auditor Client shall be subject to the terms of this Agreement to the extent such terms are applicable. This Agreement also applies to your use of any additional materials, services or functions that we may make available to you from time to time.\n\nBy clicking to agree and/or using the Licensed Materials, you confirm your agreement to the terms of this Agreement.\nIf you do not agree, do not use the Licensed Materials and immediately exit the LPT Audit Platform.',
      'Definitions\n\n"Agreement" or "Agreements" means this Agreement and terms, including all of its Terms and Conditions, Addenda, Service Level Agreement, the Data Processing Agreement and each of the Policies as incorporated herein, and all appendices, schedule and exhibits as they may be amended from time to time.\n"Acceptable Use Policy" means the policy available at the LPT website which is incorporated by reference into this Agreement.\n"Affiliate" means, with respect to a party, any entity that controls, is controlled by, or which is under common control with such party.\n"Authorized Users" means employees or independent contractors of Licensee who have been authorized to access the Licensed Materials, subject to the terms and conditions of this Agreement.\n"Content" or "Contents" means all content available on or through the Licensed Materials, including without limitation all text, data, illustrations, performances, images, trademarks, trade names, and logos.\n"Client" means an individual or entity that has engaged LPT Audit or an Auditor to conduct an audit.\n"Addendum" means an agreement specifying the terms and conditions of use of the Licensed Materials for an Audit Standard and/or Template, to which LPT Audit may provide updates, revisions, or additions from time to time.\n"Auditor" means an individual or entity that conducts audits on behalf of a Client.\n"Auditor Client" means an individual or entity that has engaged an Auditor to conduct an audit.\n"Audit Standard" means an auditing standard specified in a relevant Addendum, as incorporated into the Licensed Materials.\n"Authorized Purpose" means the sole purpose of conducting an audit or related activity.\n"Authorized Person" means a person authorized to access the Licensed Materials.\n"Data Processing and Security Agreement" or "DPA" means the agreement regarding processing of personal data available at the LPT website.\n"Licensee" means the individual or entity that has been granted a license to use the Licensed Materials.\n"Licensed Materials" means the Audit Software, Report Template(s), Addenda, and/or other materials made available to a Licensee.\n"Policies" means the policies available at the LPT website.\n"Report Template" or "Template" means a report template.\n"Service Level Agreement" or "SLA" means the agreement regarding the availability of the Licensed Materials as a Service.\n"User Guide" means the instructions for use of the Licensed Materials available at the LPT website.\n"Version" means any version number of the Licensed Materials.',
      'Conditions and Restrictions\n\nUse of the Licensed Materials is subject to the Agreement.\nWe may suspend or terminate the License at any time if we determine, in our sole discretion, that Licensee has breached this Agreement.\nLicensee must ensure each Auditor Client agrees to the LPT Audit Client Terms of Use prior to use of Licensed Materials by Auditor Client.',
      'Privacy Policy\n\nLPT collects and processes personal data in accordance with the Privacy Policy.\nAll data is handled in compliance with applicable data protection regulations.',
      'License Grant\n\nSubject to the terms and conditions of this Agreement, LPT grants Licensee a non-exclusive, non-transferable, worldwide, revocable license to use the Licensed Materials solely for the Authorized Purpose and during the License Term.\nNo other rights are granted under this Agreement.',
      'Ownership and Intellectual Property\n\nThe Licensed Materials are owned by LPT or its licensors.\nAll intellectual property rights in the Licensed Materials remain exclusively with LPT and its licensors.',
      'Fees and Payment\n\nFees for use of the Licensed Materials are as set forth in the applicable Addendum or pricing schedule.\nAll fees are non-refundable unless otherwise stated.'
    ]
  },
  resetPassword: {
    backButtonTitle: 'Go Back',
    title: 'Reset Password',
    subtitle: 'Enter your email, verification code, and new password.',
    emailLabel: 'Email Address',
    emailPlaceholder: 'Enter your email',
    verificationCodeLabel: 'Verification Code',
    verificationCodePlaceholder: 'Enter the code',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Enter a new password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Enter the new password again',
    sendCodeButton: 'Send Code',
    codeCountdown: '{seconds}s',
    submitButton: 'Reset Password',
    loginPrompt: 'Remember your password?',
    loginLink: 'Sign In',
    codeSent: 'Verification code sent',
    codeSendFailed: 'Failed to send verification code',
    resetSuccess: 'Password reset successfully',
    resetFailed: 'Password reset failed',
    formInvalid: 'Please fill in correctly',
    validation: {
      emailRequired: 'Please input email address',
      emailInvalid: 'Please input correct email address',
      codeRequired: 'Please input verification code',
      passwordRequired: 'Please input new password',
      passwordMin: 'Password must be at least 8 characters',
      confirmPasswordRequired: 'Please confirm the new password',
      passwordMismatch: 'The two passwords do not match'
    }
  },
  register: {
    title: 'Create Account',
    subtitle: 'Fill in the information below to get started.',
    backButtonTitle: 'Go back',
    orgInfoSection: 'Organization Info',
    addressSection: 'Address & Contact',
    adminSection: 'Admin Info',
    nameLabel: 'Organization Name',
    namePlaceholder: 'Enter organization name',
    legalNameLabel: 'Legal Name',
    legalNamePlaceholder: 'Enter legal name',
    industryLabel: 'Industry',
    industryPlaceholder: 'Select industry (multiple)',
    regTypeLabel: 'Registration Type',
    regTypePlaceholder: 'Select type',
    regNumLabel: 'Registration Number',
    regNumPlaceholder: 'Enter registration number',
    regNumTooltip: 'The official registration number issued by your local authority.',
    taxIdLabel: 'Tax ID Number',
    taxIdPlaceholder: 'Enter tax ID number',
    legalRepLastNameLabel: 'Legal Rep Last Name',
    legalRepLastNamePlaceholder: 'Enter last name',
    legalRepFirstNameLabel: 'Legal Rep First Name',
    legalRepFirstNamePlaceholder: 'Enter first name',
    addressLine1Label: 'Address Line 1',
    addressLine1Placeholder: 'Enter street address',
    addressLine2Label: 'Address Line 2',
    addressLine2Placeholder: 'Enter apartment, suite, etc. (optional)',
    countryLabel: 'Country/Region',
    countryPlaceholder: 'Select country/region',
    stateLabel: 'State/Province',
    statePlaceholder: 'Enter state/province',
    cityLabel: 'City',
    cityPlaceholder: 'Enter city',
    postalCodeLabel: 'Postal Code',
    postalCodePlaceholder: 'Enter postal code',
    contactEmailLabel: 'Contact Email',
    contactEmailPlaceholder: 'Enter contact email',
    phoneLabel: 'Phone Number',
    phonePlaceholder: 'Enter phone number',
    lastNameLabel: 'Last Name',
    lastNamePlaceholder: 'Enter last name',
    firstNameLabel: 'First Name',
    firstNamePlaceholder: 'Enter first name',
    adminEmailLabel: 'Admin Email',
    adminEmailPlaceholder: 'Enter admin email',
    verificationCodeLabel: 'Email Verification Code',
    verificationCodePlaceholder: 'Enter 6-digit code',
    sendCodeButton: 'Send Code',
    codeCountdown: '{seconds}s',
    codeSent: 'Verification code sent to admin email',
    codeSendFailed: 'Failed to send verification code',
    adminPhoneLabel: 'Admin Phone',
    adminPhonePlaceholder: 'Enter admin phone',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm password',
    adminAddressLine1Label: 'Admin Address Line 1',
    adminAddressLine1Placeholder: 'Enter admin street address',
    adminAddressLine2Label: 'Admin Address Line 2',
    adminAddressLine2Placeholder: 'Enter admin apartment, suite, etc. (optional)',
    adminCountryLabel: 'Admin Country/Region',
    adminCountryPlaceholder: 'Select country/region',
    adminStateLabel: 'Admin State/Province',
    adminStatePlaceholder: 'Enter admin state/province',
    adminCityLabel: 'Admin City',
    adminCityPlaceholder: 'Enter admin city',
    adminPostalCodeLabel: 'Admin Postal Code',
    adminPostalCodePlaceholder: 'Enter admin postal code',
    agreementCheckbox: 'I have read and agree to the ',
    agreementLink: 'Terms and Conditions',
    submitButton: 'Submit',
    resetButton: 'Reset',
    termsOfService: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    viewTerms: 'Terms and Conditions',
    viewPrivacy: 'Privacy Policy',
    termsClose: 'Close',
    termsCloseButton: 'Close',
    termsAgreeButton: 'Agree',
    termsContent: [
      '幸运丹鸟（珠海）科技有限公司Agreements, Terms and Conditions',
      'License Term\n\nThe license begins on the Effective Date (12 months from date of payment) except for the LPT Audit Enterprise Subscription License which begins at the end of the implementation period for the LPT Audit Enterprise solution.\nEach license may be renewed for an additional term of 12 months, except for LPT Audit Enterprise License which is not renewable, and LPT Audit Lite License, whose term may not be extended except at the sole discretion of LPT.',
      'Conditions and Restrictions\n\nUse of the Licensed Materials is subject to the Agreement.\nWe may suspend or terminate the License at any time if we determine, in our sole discretion, that Licensee has breached this Agreement.\nLicensee must ensure each Auditor Client agrees to the LPT Audit Client Terms of Use prior to use of Licensed Materials by Auditor Client.',
      'Privacy Policy\n\nLPT collects and processes personal data in accordance with the Privacy Policy.\nAll data is handled in compliance with applicable data protection regulations.',
    ],
    privacyContent: 'This is the privacy policy for the LPT audit platform. All personal data is processed in compliance with applicable data protection regulations. For more details, please contact our support team.',
    accountCreateSuccess: 'Account created successfully',
    accountCreateFail: 'Failed to create account',
    formError: 'Please fill in all required fields correctly',
    validation: {
      confirmPasswordMismatch: 'Passwords do not match',
      passwordRequired: 'Please input password',
      passwordInvalid: 'Password must be at least 8 characters, including one uppercase letter, one lowercase letter, and one number',
      orgNameRequired: 'Please input organization name',
      legalNameRequired: 'Please input legal name',
      contactEmailRequired: 'Please input contact email',
      emailInvalid: 'Please input a valid email address',
      phoneRequired: 'Please input phone number',
      regTypeRequired: 'Please select registration type',
      regNumRequired: 'Please input registration number',
      taxIdRequired: 'Please input tax ID number',
      legalRepLastNameRequired: 'Please input legal representative last name',
      legalRepFirstNameRequired: 'Please input legal representative first name',
      addressRequired: 'Please input address',
      stateRequired: 'Please input state or province',
      cityRequired: 'Please input city',
      postalCodeRequired: 'Please input postal code',
      countryRequired: 'Please select country/region',
      adminEmailRequired: 'Please input admin email',
      verificationCodeRequired: 'Please input the verification code',
      verificationCodeInvalid: 'Verification code must be 6 digits',
      firstNameRequired: 'Please input first name',
      lastNameRequired: 'Please input last name',
      agreementRequired: 'You must agree to the Terms and Conditions'
    },
    industryOptions: {
      platforms: 'Platforms',
      advertising: 'Advertising',
      energy: 'Energy',
      data_and_analytics: 'Data & Analytics',
      messaging_and_telecommunications: 'Messaging & Telecommunications',
      lending_and_investments: 'Lending & Investments',
      real_estate: 'Real Estate',
      consumer_electronics: 'Consumer Electronics',
      administrative_services: 'Administrative Services',
      health_care: 'Health Care',
      agriculture_and_farming: 'Agriculture & Farming',
      community_and_lifestyle: 'Community & Lifestyle',
      social_impact: 'Social Impact',
      events: 'Events',
      clothing_and_apparel: 'Clothing & Apparel',
      video: 'Video',
      internet_services: 'Internet Services',
      travel_and_tourism: 'Travel & Tourism',
      information_technology: 'Information Technology',
      content_and_publishing: 'Content & Publishing',
      mobile: 'Mobile',
      government_and_military: 'Government & Military',
      artificial_intelligence: 'Artificial Intelligence',
      blockchain_and_cryptocurrency: 'Blockchain & Cryptocurrency',
      sustainability: 'Sustainability',
      hardware: 'Hardware',
      sales_and_marketing: 'Sales & Marketing',
      transportation: 'Transportation',
      payments: 'Payments',
      gaming: 'Gaming',
      science_and_engineering: 'Science & Engineering',
      apps: 'Apps',
      biotechnology: 'Biotechnology',
      professional_services: 'Professional Services',
      navigation_and_mapping: 'Navigation & Mapping',
      design: 'Design',
      sports: 'Sports',
      education: 'Education',
      natural_resources: 'Natural Resources',
      commerce_and_shopping: 'Commerce & Shopping',
      manufacturing: 'Manufacturing',
      media_and_entertainment: 'Media & Entertainment',
      software: 'Software',
      consumer_goods: 'Consumer Goods',
      other: 'Other',
      music_and_audio: 'Music & Audio',
      privacy_and_security: 'Privacy & Security',
      financial_services: 'Financial Services',
      food_and_beverage: 'Food & Beverage'
    },
    registrationTypeOptions: {
      china_business_license: 'China Business License',
      germany_handelsregister: 'Germany Handelsregisterauszug',
      other: 'Other'
    },
    registrationTypesLoading: 'Loading…',
    registrationTypesEmpty: 'No registration types available',
    registrationNumberExample: 'Example'
  },
  faq: {
    hero: {
      badge: 'Help Center',
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about the LPT Audit Platform. Find answers to common questions below.',
      searchPlaceholder: 'Search questions...'
    },
    quickTags: {
      pricing: 'Pricing',
      security: 'Data Security',
      iso: 'ISO Standards',
      trial: 'Free Trial'
    },
    categories: {
      all: 'All Questions',
      general: 'General Info',
      pricing: 'Pricing & Plans',
      features: 'Features & Capabilities',
      security: 'Security & Compliance',
      account: 'Account & Users',
      technical: 'Technical Support'
    },
    searchResults: 'Found {count} results for "{query}"',
    clearSearch: 'Clear Search',
    helpful: 'Was this helpful?',
    yes: 'Yes',
    no: 'No',
    thanksFeedback: 'Thanks for your feedback!',
    noResults: 'No matching questions found',
    noResultsDesc: 'Please adjust your search keywords or browse all categories.',
    showAll: 'Show All Questions',
    cta: {
      title: 'Still have questions?',
      subtitle: 'Our audit experts are ready to find the right solution for your organization.',
      contactSupport: 'Contact Support',
      bookDemo: 'Book a Demo'
    },
    items: {
      whatIsLpt: {
        q: 'What is the LPT Software Platform?',
        a: 'LPT Software Platform is a comprehensive, cloud-based audit management and management system solutions designed for professional auditors and organizations. It supports multiple international standards including ISO 9001, ISO 14001, ISO 27001, IATF 16949, VDA 6.3, and more, providing end-to-end audit workflow management from planning to reporting.'
      },
      auditStandards: {
        q: 'Which audit standard are supported?',
        a: 'We support a wide range of international standards including ISO 9001, IATF 16949, VDA 6.3, ISO 14001, ISO 45001, TISAX and ISO 27001. You can also create custom audit templates using our Template Creator tool.'
      },
      getStarted: {
        q: 'How do I get started with our software solutions?',
        a: 'Getting started is easy: 1) Register your organization account, 2) Choose a subscription plan, 3) Select your audit standards, 4) Invite your auditors. You can be up and running in minutes.'
      },
      pricingPlans: {
        q: 'What pricing plans are available?',
        a: 'We offer several options, which also can bring you a great deal of saving. Please refer to our products for more details.'
      },
      cancelSubscription: {
        q: 'Can I cancel or change my subscription?',
        a: 'Yes, you can change or cancel your subscription from your account settings.'
      },
      paymentMethods: {
        q: 'What payment methods are accepted?',
        a: 'We accept Visa, Mastercard, Wechat and Alipay and others depending in which country you are. All payments are processed through our secure, PCI DSS compliant payment gateway.'
      },
      customTemplates: {
        q: 'Can I create custom audit templates?',
        a: 'Yes, there are two ways of creating your own audit templates. One of our software solutions includes a powerful template creator tool for building tailored checklists and scoring criteria. Another way ist o contact us in case you have specific templates and you cannot find them in our portfolio.'
      },
      supplierPortalWork: {
        q: 'How does the supplier portal works?',
        a: 'The supplier portal provides your suppliers with unlimited free access to respond to audits, upload evidence, and manage action management as required and defined by the auditor.'
      },
      shareAuditsInternal: {
        q: 'Can I share my audits within the organization?',
        a: 'Yes, the auditor can add internal user to the internal pool and give them free access tot he software platform.'
      },
      accessCost: {
        q: 'Does the access for suppliers, internal users, clients and others cost money?',
        a: 'No, those accesses are included in all of our audit software solutions.'
      },
      shareAuditsExternal: {
        q: 'Can I share my audits with the certification body or a client?',
        a: 'Yes, you can share them and the access fort hem are free. You can create an account for them and they can get access to the audits you share.'
      },
      offlineMode: {
        q: 'Can I use my audit software offline?',
        a: 'Yes, our audit software solutions has a offline mode.'
      },
      exportAudits: {
        q: 'Can I export my audits?',
        a: 'You can share your audits with everyone for free. They will have access through the portal and have access to audits shared by the auditor.'
      },
      removeAccess: {
        q: 'How can I remove the access or a audit, once I have shared it?',
        a: 'You can un-share audits and delete accesses at any time as auditor.'
      },
      dataSecurity: {
        q: 'How is my data secured?',
        a: 'All data is encrypted at rest (AES-256) and in transit (TLS 1.3). Our management system and infrastructure is in reference to ISO 27001 and TISAX.'
      },
      backupHandling: {
        q: 'How are the backups handled?',
        a: 'We perform automated regular backups with geo-redundancy.'
      },
      auditorLimit: {
        q: 'Is there a limit on the number of auditors or audits?',
        a: 'No, there is not limit to auditors or audits. The licences are bind to the auditors, but you can always add new licences and auditors to your auditor pool.'
      },
      supportedLanguages: {
        q: 'What languages are supported?',
        a: 'Our software currently supports English, Chinese, German, Spanish, French. Reports can also be generated in these languages.'
      },
      auditManagementSupport: {
        q: 'How does this audit software spports my audit management?',
        a: 'Our audit software provides a wide range of support. The audit report for example is automatically created while the auditor conducts the audit. The auditor can afterwards review the audit report and can adjust as required or wished.<br><br>The workflow of an audit is implemented and supports the auditor active. Each standard chapter is already implemented and switches automatical if for example a non-confirmity is raised by the auditor.'
      },
      inexexperiencedUser: {
        q: 'Can I use the audit software, even if I have less experience with auditing?',
        a: 'Yes, our audit software is intuitive developed and guide you through the audit. The automatic infrastructure is created by third-party auditors around the world to ensure the conformity of the workflow.'
      },
      uploadFiles: {
        q: 'Can I upload files or pictures to my audit?',
        a: 'Yes, you can take picture or files and upload them into your audit.'
      },
      multipleAuditors: {
        q: 'Can I conduct an audit with multiple auditors?',
        a: 'Yes, you can conduct an audit with multiple auditors. All auditors can work together in our software at the same time. The auditors have to be added to the auditor pool, so you can add them to the audit as Lead-auditor or Co-auditor.'
      },
      buyLicences: {
        q: 'Who can buy licences and create auditor?',
        a: 'The licences and binding auditors to the licences can only be done at the platform and by the administrator. Please be aware that the licences are bind to the auditor and cannot be switched to another auditor. Each auditor needs his own licence.'
      },
      addTemplates: {
        q: 'Can I add more audit templates later to my account?',
        a: 'Yes, you can add at anytime new audit templates to your account. After purchasing the template will be available.'
      },
      templatePurchase: {
        q: 'Do I have to purchase templates for each auditor separately?',
        a: 'No, once the organization has purchased an audit template, it can be used by all licenced auditors bind to the organization.'
      }
    }
  },
  more: 'More',
  productionBrain: {
    downloadShortcut: {
      title: 'Download Website Shortcut',
      desc: 'One-click access to LPT Audit Platform',
      btn: 'Download Now'
    },
    hero: {
      badge: 'The Connected Platform',
      title: 'Elevate Audit from Checklist to Strategic Asset',
      desc1: 'Unify your Risk, Compliance and Audit Management on a single, powered platform.',
      desc2: 'Automate Audit Management, improve the effectiveness of your audit team through automated and lean workflows.',
      btnShop: 'SHOP',
      btnExplore: 'Explore Platform Tour'
    },
    stats: {
      timeSaved: { value: '>30%', label: 'Time Saved', desc: 'Average annual time saved on manual evidence collection.' },
      riskVisibility: { value: 'Real-Time', label: 'Risk Visibility', desc: 'Transition from point-in-time checks to continuous assurance.' },
      integrations: { value: '100+', label: 'Integrations', desc: 'Plug into your existing infrastructure seamlessly.' },
      surpriseFindings: { value: 'Zero', label: 'Surprise Findings', desc: 'Catch control failures before external auditors arrive.' }
    },
    solutions: {
      header: {
        title: 'Purpose-Built for Every Line of Business',
        desc: 'Whether you\'re managing complex, simple or flexible audits or management systems around the world or local, our solutions adapt to your specific methodology.'
      },
      items: [
        {
          title: 'Audit Management',
          description: 'Streamline the entire audit lifecycle. Automate assessments, workflow management and dynamic reporting fort he audit team.'
        },
        {
          title: 'IT & Security Compliance',
          description: 'Accelerate ISO 27001, TISAX, PCI-DDS and HIPAA compliance. Control mapping ensures you test, review and comply across multiple frameworks.'
        },
        {
          title: 'Automated Workflow',
          description: 'Digitize your audit workflow and management. Automated workflows through the entire audit procedures.'
        },
        {
          title: 'Digitalization',
          description: 'Digitize your audit management and compliance program. Track RCMs (Risk Control Matrix), manage certifications and automate definciency workflows.'
        }
      ]
    },
    features: {
      header: {
        title: 'Enterprise-Grade Capabilities',
        desc: 'A comprehensive toolkit designed to centralize data, automate workflows, and provide actionable analytics.'
      },
      items: [
        {
          title: 'Data-Driven Risk Assessments',
          description: 'Perform upfront and backward risk assessments based on your audit results and reviews.',
          list: ['Custom Risk Scoring', 'Heatmap Generation', 'Dynamic Risk Registers']
        },
        {
          title: 'Direct Implementation',
          description: 'Eliminate separate folders with evidences. Implement files, photos etc. directly into your audit.',
          list: ['Upload photos into the audit', 'Upload files into the audit', 'Upload to library']
        },
        {
          title: 'Issue & Remediation Tracking',
          description: 'Don\'t let findings fall through the cracks. Assign issues, set deadlines, and track remediation plans through to closure.',
          list: ['Automated action management', 'Automated Follow-ups', 'Integrated supplier action management']
        },
        {
          title: 'Consistency through automatization',
          description: 'Connected functions ensure consistent data and information through out the entire audit procedures.',
          list: ['Automatic syncronization', 'Automated transfer between audit procedure', 'Failure prevention through workflow']
        },
        {
          title: 'Smart Framework Management',
          description: 'Automated links and connections between the differtent tools ensure effectivity asnd efficiency.',
          list: ['Crosswalk Mapping', 'Pre-built Frameworks', 'Gap Analysis']
        },
        {
          title: 'Advanced Active Directory',
          description: 'Keep all your data in your audit cockpit. Invite suppliers and clients to join by still keeping the key in your hands. Define the access permissions and roles.',
          list: ['Controlled invitations', 'Managed accesses by auditor', 'Controlled audit sharing']
        }
      ]
    },
    integration: {
      title: 'Digitalize Your Entire Audit Management',
      desc: 'Our software solutions provide an entire audit management system. All data and information will be digital available and compliant with the standards provided by us.',
      benefits: {
        digitalization: { label: 'Full Digitalization:', text: 'One single software for your audit management.' },
        sync: { label: 'Continuos Sync:', text: 'Regular syncs ensure your compliance posture is always up to date.' },
        data: { label: 'Controlled Data:', text: 'You control the sharing and unsharing of your audit data.' }
      },
      nodes: {
        center: 'Audit',
        offline: 'Offline Mode',
        portal: 'Supplier Portal',
        templates: 'Ready-to-go templates',
        workflows: 'Automated Workflows',
        permissions: 'Permission Management',
        library: 'Digital Library'
      }
    },
    workflow: {
      header: {
        title: 'The Intelligent Audit Lifecycle',
        desc: 'A streamlined process designed for maximum efficiency and absolute accuracy from planning to reporting.'
      },
      items: [
        {
          title: '1. Plan & Scope',
          description: 'Define your strategy, align with risk registers, and automatically allocate resources based on auditor availability.'
        },
        {
          title: '2. Auditing',
          description: 'Utilize digital workpapers, collaborate in real-time within the platform, and capture automated evidence seamlessly.'
        },
        {
          title: '3. Review & Remediate',
          description: 'Highlight discrepancies instantly. Route findings automatically to action owners for swift remediation.'
        },
        {
          title: '4. Report & Monitor',
          description: 'Publish final audit reports instantly. Shift to continuous monitoring to ensure controls remain effective year-round.'
        }
      ]
    },
    value: {
      title: 'Bank-Grade Security & Reliability',
      lead: 'Your audit data is your most sensitive asset. We protect it with enterprise-grade security architecture designed to meet the strictest global standards.',
      props: [
        {
          title: 'Data Residency & Compliance',
          desc: 'Host your data in regional AWS/Azure data centers to comply with local data protection laws (GDPR, CCPA).'
        },
        {
          title: 'Role-Based Access Control (RBAC)',
          desc: 'Granular permissions ensure users only see the data, controls, and workflows assigned to them.'
        },
        {
          title: 'Immutable Audit Trails',
          desc: 'Every change, sign-off, and configuration update is logged cryptographically. Audit the audit platform itself.'
        }
      ]
    },
    cta: {
      title: 'Ready to modernize your audit processes?',
      desc: 'Join hundreds of leading enterprises that have transformed their audit management and operations into effective and efficient operations.',
      btn: 'Start Your Assessment Today'
    }
  },
  services: {
    research: {
      website: 'Visit the CBIB trend line',
      categories: [
        { title: 'Government-oriented', description: 'Strategic research supporting government decision-making.' },
        { title: 'Digital economy-oriented', description: 'Research on industrial digital infrastructure and new management models.' },
        { title: 'Industry-oriented', description: 'Index research products that provide tools for policy and industry analysis.' },
        { title: 'Data-driven', description: 'Digital research connecting industrial data, indicators and knowledge graphs.' }
      ]
    },
    consulting: {
      banner: {
        title: "Industrial Consulting Services",
        desc: "One-stop strategic consulting services for the development of biopharmaceutical industry"
      },
      intro: {
        title: "LPT Industrial Consulting Introduction",
        desc: "Providing strategic consulting services such as industrial research, planning, assessment, and monitoring"
      },
      advantage: {
        title: "LPT Industrial Consulting Unique Advantages"
      },
      values: {
        title: "BioMall Four Core Values",
        items: [
          {
            title: "Data Driven",
            desc: "Based on data advantages in industry chain, innovation chain, space chain and government chain, we provide professional regional biopharmaceutical industry data evaluation services."
          },
          {
            title: "Integrated Solutions",
            desc: "Formulate theoretical guidance of 'industrial research + planning blueprint + resource integration + platform implementation', providing unique regional biopharmaceutical industry research solutions."
          },
          {
            title: "Professional Service Team",
            desc: "Focus on the largest biopharmaceutical industry research professional team in China. Core members have many years of industry research and consulting experience."
          }
        ]
      },
      appointment: {
        title: "Consult Our Industry Experts<br>Learn more about LPT Industrial Consulting Services",
        hotline: "Call our consultation hotline: 000-000-0000"
      },
      witness: {
        title: "Client Testimonials",
        desc: "150+ successful cooperation cases with governments and industrial parks across the country"
      },
      list: [
        {
          tit: 'Industrial Research',
          content: 'Based on CBIB benchmarking analysis, we use data to interpret the strengths and weaknesses of regional industrial development, quantify development gaps, and present development status comprehensively and objectively.',
          images: [
            'China Biopharmaceutical Industry Blue Book',
            'Guangzhou Development Zone Blue Book',
            'Pingshan Biological Industry Base Blue Book',
            'Rizhao Economic Development Zone Blue Book, etc.'
          ]
        },
        {
          tit: 'Industrial Planning',
          content: 'Use data-driven industrial positioning to clarify development goals and paths, integrate professional service platforms, and form overall solutions from top-level design to service operation.',
          images: [
            'Chongqing Liangjiang New Area Shuitu Park Biopharmaceutical Industry Development Plan',
            'Hangzhou Pharmaceutical Port Industry Development Plan',
            'Hangzhou High-tech Zone Industry Development Plan',
            'Zhongguancun Life Science Park Changli Science and Innovation Base Industrial Plan'
          ]
        },
        {
          tit: 'Project Assessment',
          content: 'Based on macro-economic evaluation, technical trend assessment combined with park ecological environment construction evaluation and park development stage evaluation model.',
          images: [
            'Hangzhou High-tech Zone Enterprise Investment Assessment',
            'WuXi Biologics Variety Investment Assessment, etc.'
          ]
        },
        {
          tit: 'Industrial Monitoring',
          content: 'Through industrial dynamic data monitoring, form newsletters on regional economic entities, innovation results, and policy changes to help parks track regional and industrial development.',
          images: [
            'National Development and Reform Commission Briefing',
            'Beijing Biological Center Policy Briefing',
            'Xi\'an High-tech Zone Briefing, etc.'
          ]
        },
        {
          tit: 'Special Research',
          content: 'Analyze domestic and international industrial status from multiple dimensions; clarify regional strengths and weaknesses through benchmarking analysis with advanced regions.',
          images: [
            'NDRC Policy Impact Evaluation',
            'Beijing Biological Center Special Policy Analysis',
            'Suzhou Industrial Park Multi-field Special Research',
            'Guangzhou Generic Drug Policy Research'
          ]
        }
      ],
      cases: [
        { tit: 'Shanghai Biopharmaceutical Industry Map' },
        { tit: 'Shanghai Biopharmaceutical Innovation Service Platform' },
        { tit: 'Guangzhou Biopharmaceutical Industry Map' },
        { tit: 'Zhongguancun Development Group (Planning + Digital Middle Platform)' },
        { tit: 'Zhongguancun Life Science Park Smart Park' },
        { tit: 'China Fortune Land Development Data Platform' }
      ]
    },
    recruitment: {
      banner: {
        title: "Cloud Recruitment, Expert in Enterprise Site Selection",
        desc: "Based on enterprise big data and investment logic<br />Helping government parks transform to intelligent digital recruitment"
      },
      challenges: {
        title: "2020, New Challenges for Government and Park Recruitment!",
        items: [
          "During the pandemic, how to promote rapid resumption of recruitment work?",
          "How to accelerate industrial development and enhance professional services under the industrial new infrastructure wave?",
          "How to effectively promote park value and expand brand influence?",
          "How to gain insights into external environment and industry trends to promote project landing?"
        ]
      },
      cloud: {
        title: "Cloud Recruitment",
        desc: "Innovative one-stop online recruitment solution",
        list: [
          {
            tit: 'Online Recruitment Fair',
            content: 'Organize and plan online promotion conferences and negotiation meetings for parks, providing full-process services from planning to promotion.',
            features: [
              '<strong>Launch with one click</strong> Rapidly hold online recruitment fairs',
              '<strong>Exclusive QR Code</strong> VIP experience for every participant',
              '<strong>Stable & Smooth</strong> Generate meeting outcome reports instantly'
            ]
          },
          {
            tit: 'Intelligent Recruitment SAAS',
            content: 'Based on big data, integrate recruitment leads, accurately match regional strategies with target enterprises nationwide.',
            features: [
              '<strong>Customized Models</strong> 45 prediction models built on regional and sectoral recruitment logic',
              '<strong>Continuous Data</strong> 2M+ medical companies, 250K+ products, 700K+ clinical data...',
              '<strong>Intelligence Mining</strong> Extract recruitment intel from massive data in real-time',
              '<strong>Effective Connection</strong> Facilitate project landing via online and offline integration'
            ]
          },
          {
            tit: 'Digital Twin Park',
            content: 'Enable digital functions for park business environment, including VR real scenes, digital public services and platforms.',
            features: [
              '<strong>VR Panorama</strong> Comprehensive display of park real scenes',
              '<strong>3D Modeling</strong> Visually present future planning',
              '<strong>Micro Park</strong> Detailed introduction of park facilities'
            ]
          }
        ]
      },
      prediction: {
        line1: "45+ Recruitment prediction models for biopharm sub-sectors",
        line2: "Rapidly form precision profiles exclusive to your park",
        line3: "Output dynamically updated target client lists",
        btn: "Apply for Free Trial"
      },
      location: {
        title: "Drug Selection",
        subtitle: "MedSite Platform",
        desc: "Effectively reach over 20,000 high-quality biopharmaceutical companies",
        detail: "Provide accurate, real and effective enterprise site selection leads and project information. Build online digital marketing platforms.",
        btn: "Enter MedSite"
      },
      witness: {
        title: "Client Testimonials",
        desc: "150+ governments and biopharmaceutical parks choose LPT"
      }
    },
    innovation: {
      title: 'Biopharmaceutical Industry Development',
      subtitle: 'Digital research and innovation for the life and health economy',
      banner: {
        title: "Enterprise Innovation Services",
        desc: "Building life health industry new infrastructure, accelerating high-quality development of SMEs"
      },
      menu: {
        biomall: "BioMall - Biopharmaceutical Innovation Service Complex",
        medical: "Medical Device Innovation Demonstration Base"
      },
      supplyChain: {
        title: "Biopharmaceutical Supply Chain is Crucial",
        desc: "Throughout the product lifecycle from R&D to marketing. Using digital levers is an inevitable path for parks."
      },
      stakeholders: [
        {
          title: "Park Government",
          desc: "How to improve professional service capabilities and provide more supply chain options?"
        },
        {
          title: "Service Providers",
          desc: "How to get closer to customers and further expand market coverage?"
        },
        {
          title: "Park Enterprises",
          desc: "How to obtain more professional technical services and match valuable providers?"
        }
      ],
      mall: {
        title: "Introduction to BioMall",
        desc: "BioMall is an innovation infrastructure that accelerates SME innovation and enhances park service levels. It integrates online and offline resources to provide high-quality, cost-effective products and services."
      },
      functions: {
        title: "BioMall Function System"
      },
      platforms: [
        {
          title: "Digital Procurement",
          features: ["Product Search", "Online Order", "Order Management", "Contract Management"]
        },
        {
          title: "Digital Marketing",
          features: ["Precision Acquisition", "Inquiry Management", "Private Domain", "Exhibition Services"]
        },
        {
          title: "Digital Public Service",
          features: ["Policy Application", "R&D Service", "Talent Service", "Financial Service"]
        },
        {
          title: "Digital Supply Chain",
          features: ["Smart Logistics", "Warehouse Management", "Distribution Service", "Customs Service"]
        }
      ],
      values: {
        title: "BioMall Four Core Values",
        items: [
          "Not just online digital infra, but a comprehensive online-offline integration",
          "Enhance resource allocation to accelerate biopharmaceutical industry clustering",
          "Solve supply chain bottlenecks in the development of biopharmaceuticals",
          "Attract quality suppliers to nurture upstream chains and increase regional GDP/Tax"
        ]
      }
    },
    common: {
      learnMore: "Learn More",
      getDemo: "Get Demo",
      applyFree: "Apply for Free",
      buyNow: "Buy Now",
      followUs: "Follow LPT",
      contactPhone: "Contact: 000-000-0000"
    }
  }
  ,
  actionManagement: {
    generalInfo: {
      evaluation: "Evaluation"
    },
    submitChanges: "Submit Changes"
  }
}
